import {
  loadGraphModel
} from "./chunk-6LBCAEH2.js";
import {
  Tensor,
  add,
  argMax,
  backend,
  browser_exports,
  cast,
  clipByValue,
  concat,
  dispose,
  div,
  engine,
  env,
  exp,
  expandDims,
  getBackend,
  image,
  minimum,
  mirrorPad,
  mul,
  pad,
  reshape,
  scalar,
  sigmoid,
  slice,
  square,
  squeeze,
  sub,
  tensor1d,
  tensor2d,
  tidy,
  util_exports,
  zeros
} from "./chunk-A2ISTGEH.js";
import {
  __commonJS,
  __toESM
} from "./chunk-J43GMYXM.js";

// node_modules/@mediapipe/pose/pose.js
var require_pose = __commonJS({
  "node_modules/@mediapipe/pose/pose.js"(exports) {
    (function() {
      "use strict";
      var x;
      function aa(a) {
        var b = 0;
        return function() {
          return b < a.length ? { done: false, value: a[b++] } : { done: true };
        };
      }
      var ba = "function" == typeof Object.defineProperties ? Object.defineProperty : function(a, b, c) {
        if (a == Array.prototype || a == Object.prototype)
          return a;
        a[b] = c.value;
        return a;
      };
      function ca(a) {
        a = ["object" == typeof globalThis && globalThis, a, "object" == typeof window && window, "object" == typeof self && self, "object" == typeof global && global];
        for (var b = 0; b < a.length; ++b) {
          var c = a[b];
          if (c && c.Math == Math)
            return c;
        }
        throw Error("Cannot find global object");
      }
      var y = ca(this);
      function B2(a, b) {
        if (b)
          a: {
            var c = y;
            a = a.split(".");
            for (var d = 0; d < a.length - 1; d++) {
              var e = a[d];
              if (!(e in c))
                break a;
              c = c[e];
            }
            a = a[a.length - 1];
            d = c[a];
            b = b(d);
            b != d && null != b && ba(c, a, { configurable: true, writable: true, value: b });
          }
      }
      B2("Symbol", function(a) {
        function b(g) {
          if (this instanceof b)
            throw new TypeError("Symbol is not a constructor");
          return new c(d + (g || "") + "_" + e++, g);
        }
        function c(g, f) {
          this.g = g;
          ba(this, "description", { configurable: true, writable: true, value: f });
        }
        if (a)
          return a;
        c.prototype.toString = function() {
          return this.g;
        };
        var d = "jscomp_symbol_" + (1e9 * Math.random() >>> 0) + "_", e = 0;
        return b;
      });
      B2("Symbol.iterator", function(a) {
        if (a)
          return a;
        a = Symbol("Symbol.iterator");
        for (var b = "Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(" "), c = 0; c < b.length; c++) {
          var d = y[b[c]];
          "function" === typeof d && "function" != typeof d.prototype[a] && ba(d.prototype, a, { configurable: true, writable: true, value: function() {
            return da(aa(this));
          } });
        }
        return a;
      });
      function da(a) {
        a = { next: a };
        a[Symbol.iterator] = function() {
          return this;
        };
        return a;
      }
      function C(a) {
        var b = "undefined" != typeof Symbol && Symbol.iterator && a[Symbol.iterator];
        return b ? b.call(a) : { next: aa(a) };
      }
      function ea(a) {
        if (!(a instanceof Array)) {
          a = C(a);
          for (var b, c = []; !(b = a.next()).done; )
            c.push(b.value);
          a = c;
        }
        return a;
      }
      var fa = "function" == typeof Object.create ? Object.create : function(a) {
        function b() {
        }
        b.prototype = a;
        return new b();
      }, ha;
      if ("function" == typeof Object.setPrototypeOf)
        ha = Object.setPrototypeOf;
      else {
        var ia;
        a: {
          var ja = { a: true }, ka = {};
          try {
            ka.__proto__ = ja;
            ia = ka.a;
            break a;
          } catch (a) {
          }
          ia = false;
        }
        ha = ia ? function(a, b) {
          a.__proto__ = b;
          if (a.__proto__ !== b)
            throw new TypeError(a + " is not extensible");
          return a;
        } : null;
      }
      var la = ha;
      function E2(a, b) {
        a.prototype = fa(b.prototype);
        a.prototype.constructor = a;
        if (la)
          la(a, b);
        else
          for (var c in b)
            if ("prototype" != c)
              if (Object.defineProperties) {
                var d = Object.getOwnPropertyDescriptor(b, c);
                d && Object.defineProperty(a, c, d);
              } else
                a[c] = b[c];
        a.ea = b.prototype;
      }
      function ma() {
        this.l = false;
        this.i = null;
        this.h = void 0;
        this.g = 1;
        this.s = this.m = 0;
        this.j = null;
      }
      function na(a) {
        if (a.l)
          throw new TypeError("Generator is already running");
        a.l = true;
      }
      ma.prototype.o = function(a) {
        this.h = a;
      };
      function oa(a, b) {
        a.j = { U: b, V: true };
        a.g = a.m || a.s;
      }
      ma.prototype.return = function(a) {
        this.j = { return: a };
        this.g = this.s;
      };
      function F(a, b, c) {
        a.g = c;
        return { value: b };
      }
      function pa(a) {
        this.g = new ma();
        this.h = a;
      }
      function qa(a, b) {
        na(a.g);
        var c = a.g.i;
        if (c)
          return ra(a, "return" in c ? c["return"] : function(d) {
            return { value: d, done: true };
          }, b, a.g.return);
        a.g.return(b);
        return G2(a);
      }
      function ra(a, b, c, d) {
        try {
          var e = b.call(a.g.i, c);
          if (!(e instanceof Object))
            throw new TypeError("Iterator result " + e + " is not an object");
          if (!e.done)
            return a.g.l = false, e;
          var g = e.value;
        } catch (f) {
          return a.g.i = null, oa(a.g, f), G2(a);
        }
        a.g.i = null;
        d.call(a.g, g);
        return G2(a);
      }
      function G2(a) {
        for (; a.g.g; )
          try {
            var b = a.h(a.g);
            if (b)
              return a.g.l = false, { value: b.value, done: false };
          } catch (c) {
            a.g.h = void 0, oa(a.g, c);
          }
        a.g.l = false;
        if (a.g.j) {
          b = a.g.j;
          a.g.j = null;
          if (b.V)
            throw b.U;
          return { value: b.return, done: true };
        }
        return { value: void 0, done: true };
      }
      function sa(a) {
        this.next = function(b) {
          na(a.g);
          a.g.i ? b = ra(a, a.g.i.next, b, a.g.o) : (a.g.o(b), b = G2(a));
          return b;
        };
        this.throw = function(b) {
          na(a.g);
          a.g.i ? b = ra(a, a.g.i["throw"], b, a.g.o) : (oa(a.g, b), b = G2(a));
          return b;
        };
        this.return = function(b) {
          return qa(a, b);
        };
        this[Symbol.iterator] = function() {
          return this;
        };
      }
      function ta(a) {
        function b(d) {
          return a.next(d);
        }
        function c(d) {
          return a.throw(d);
        }
        return new Promise(function(d, e) {
          function g(f) {
            f.done ? d(f.value) : Promise.resolve(f.value).then(b, c).then(g, e);
          }
          g(a.next());
        });
      }
      function H2(a) {
        return ta(new sa(new pa(a)));
      }
      B2("Promise", function(a) {
        function b(f) {
          this.h = 0;
          this.i = void 0;
          this.g = [];
          this.o = false;
          var k = this.j();
          try {
            f(k.resolve, k.reject);
          } catch (h) {
            k.reject(h);
          }
        }
        function c() {
          this.g = null;
        }
        function d(f) {
          return f instanceof b ? f : new b(function(k) {
            k(f);
          });
        }
        if (a)
          return a;
        c.prototype.h = function(f) {
          if (null == this.g) {
            this.g = [];
            var k = this;
            this.i(function() {
              k.l();
            });
          }
          this.g.push(f);
        };
        var e = y.setTimeout;
        c.prototype.i = function(f) {
          e(f, 0);
        };
        c.prototype.l = function() {
          for (; this.g && this.g.length; ) {
            var f = this.g;
            this.g = [];
            for (var k = 0; k < f.length; ++k) {
              var h = f[k];
              f[k] = null;
              try {
                h();
              } catch (l) {
                this.j(l);
              }
            }
          }
          this.g = null;
        };
        c.prototype.j = function(f) {
          this.i(function() {
            throw f;
          });
        };
        b.prototype.j = function() {
          function f(l) {
            return function(n) {
              h || (h = true, l.call(k, n));
            };
          }
          var k = this, h = false;
          return { resolve: f(this.C), reject: f(this.l) };
        };
        b.prototype.C = function(f) {
          if (f === this)
            this.l(new TypeError("A Promise cannot resolve to itself"));
          else if (f instanceof b)
            this.F(f);
          else {
            a:
              switch (typeof f) {
                case "object":
                  var k = null != f;
                  break a;
                case "function":
                  k = true;
                  break a;
                default:
                  k = false;
              }
            k ? this.v(f) : this.m(f);
          }
        };
        b.prototype.v = function(f) {
          var k = void 0;
          try {
            k = f.then;
          } catch (h) {
            this.l(h);
            return;
          }
          "function" == typeof k ? this.G(k, f) : this.m(f);
        };
        b.prototype.l = function(f) {
          this.s(2, f);
        };
        b.prototype.m = function(f) {
          this.s(1, f);
        };
        b.prototype.s = function(f, k) {
          if (0 != this.h)
            throw Error("Cannot settle(" + f + ", " + k + "): Promise already settled in state" + this.h);
          this.h = f;
          this.i = k;
          2 === this.h && this.D();
          this.A();
        };
        b.prototype.D = function() {
          var f = this;
          e(function() {
            if (f.B()) {
              var k = y.console;
              "undefined" !== typeof k && k.error(f.i);
            }
          }, 1);
        };
        b.prototype.B = function() {
          if (this.o)
            return false;
          var f = y.CustomEvent, k = y.Event, h = y.dispatchEvent;
          if ("undefined" === typeof h)
            return true;
          "function" === typeof f ? f = new f("unhandledrejection", { cancelable: true }) : "function" === typeof k ? f = new k("unhandledrejection", { cancelable: true }) : (f = y.document.createEvent("CustomEvent"), f.initCustomEvent("unhandledrejection", false, true, f));
          f.promise = this;
          f.reason = this.i;
          return h(f);
        };
        b.prototype.A = function() {
          if (null != this.g) {
            for (var f = 0; f < this.g.length; ++f)
              g.h(this.g[f]);
            this.g = null;
          }
        };
        var g = new c();
        b.prototype.F = function(f) {
          var k = this.j();
          f.J(k.resolve, k.reject);
        };
        b.prototype.G = function(f, k) {
          var h = this.j();
          try {
            f.call(k, h.resolve, h.reject);
          } catch (l) {
            h.reject(l);
          }
        };
        b.prototype.then = function(f, k) {
          function h(p, m) {
            return "function" == typeof p ? function(q2) {
              try {
                l(p(q2));
              } catch (t2) {
                n(t2);
              }
            } : m;
          }
          var l, n, r = new b(function(p, m) {
            l = p;
            n = m;
          });
          this.J(h(f, l), h(k, n));
          return r;
        };
        b.prototype.catch = function(f) {
          return this.then(void 0, f);
        };
        b.prototype.J = function(f, k) {
          function h() {
            switch (l.h) {
              case 1:
                f(l.i);
                break;
              case 2:
                k(l.i);
                break;
              default:
                throw Error("Unexpected state: " + l.h);
            }
          }
          var l = this;
          null == this.g ? g.h(h) : this.g.push(h);
          this.o = true;
        };
        b.resolve = d;
        b.reject = function(f) {
          return new b(function(k, h) {
            h(f);
          });
        };
        b.race = function(f) {
          return new b(function(k, h) {
            for (var l = C(f), n = l.next(); !n.done; n = l.next())
              d(n.value).J(k, h);
          });
        };
        b.all = function(f) {
          var k = C(f), h = k.next();
          return h.done ? d([]) : new b(function(l, n) {
            function r(q2) {
              return function(t2) {
                p[q2] = t2;
                m--;
                0 == m && l(p);
              };
            }
            var p = [], m = 0;
            do
              p.push(void 0), m++, d(h.value).J(r(p.length - 1), n), h = k.next();
            while (!h.done);
          });
        };
        return b;
      });
      function ua(a, b) {
        a instanceof String && (a += "");
        var c = 0, d = false, e = { next: function() {
          if (!d && c < a.length) {
            var g = c++;
            return { value: b(g, a[g]), done: false };
          }
          d = true;
          return { done: true, value: void 0 };
        } };
        e[Symbol.iterator] = function() {
          return e;
        };
        return e;
      }
      var va = "function" == typeof Object.assign ? Object.assign : function(a, b) {
        for (var c = 1; c < arguments.length; c++) {
          var d = arguments[c];
          if (d)
            for (var e in d)
              Object.prototype.hasOwnProperty.call(d, e) && (a[e] = d[e]);
        }
        return a;
      };
      B2("Object.assign", function(a) {
        return a || va;
      });
      B2("Object.is", function(a) {
        return a ? a : function(b, c) {
          return b === c ? 0 !== b || 1 / b === 1 / c : b !== b && c !== c;
        };
      });
      B2("Array.prototype.includes", function(a) {
        return a ? a : function(b, c) {
          var d = this;
          d instanceof String && (d = String(d));
          var e = d.length;
          c = c || 0;
          for (0 > c && (c = Math.max(c + e, 0)); c < e; c++) {
            var g = d[c];
            if (g === b || Object.is(g, b))
              return true;
          }
          return false;
        };
      });
      B2("String.prototype.includes", function(a) {
        return a ? a : function(b, c) {
          if (null == this)
            throw new TypeError("The 'this' value for String.prototype.includes must not be null or undefined");
          if (b instanceof RegExp)
            throw new TypeError("First argument to String.prototype.includes must not be a regular expression");
          return -1 !== this.indexOf(b, c || 0);
        };
      });
      B2("Array.prototype.keys", function(a) {
        return a ? a : function() {
          return ua(this, function(b) {
            return b;
          });
        };
      });
      var wa = this || self;
      function J2(a, b) {
        a = a.split(".");
        var c = wa;
        a[0] in c || "undefined" == typeof c.execScript || c.execScript("var " + a[0]);
        for (var d; a.length && (d = a.shift()); )
          a.length || void 0 === b ? c[d] && c[d] !== Object.prototype[d] ? c = c[d] : c = c[d] = {} : c[d] = b;
      }
      ;
      function xa(a) {
        wa.setTimeout(function() {
          throw a;
        }, 0);
      }
      ;
      function K2(a) {
        xa(a);
        return;
        throw Error("invalid error level: 1");
      }
      function ya(a, b) {
        K2(Error("Invalid wire type: " + a + " (at position " + b + ")"));
      }
      function za() {
        K2(Error("Failed to read varint, encoding is invalid."));
      }
      ;
      function Aa(a, b) {
        b = String.fromCharCode.apply(null, b);
        return null == a ? b : a + b;
      }
      var Ba, Ca = "undefined" !== typeof TextDecoder, Da, Ea = "undefined" !== typeof TextEncoder;
      function Fa(a) {
        if (Ea)
          a = (Da || (Da = new TextEncoder())).encode(a);
        else {
          var b = void 0;
          b = void 0 === b ? false : b;
          for (var c = 0, d = new Uint8Array(3 * a.length), e = 0; e < a.length; e++) {
            var g = a.charCodeAt(e);
            if (128 > g)
              d[c++] = g;
            else {
              if (2048 > g)
                d[c++] = g >> 6 | 192;
              else {
                if (55296 <= g && 57343 >= g) {
                  if (56319 >= g && e < a.length) {
                    var f = a.charCodeAt(++e);
                    if (56320 <= f && 57343 >= f) {
                      g = 1024 * (g - 55296) + f - 56320 + 65536;
                      d[c++] = g >> 18 | 240;
                      d[c++] = g >> 12 & 63 | 128;
                      d[c++] = g >> 6 & 63 | 128;
                      d[c++] = g & 63 | 128;
                      continue;
                    } else
                      e--;
                  }
                  if (b)
                    throw Error("Found an unpaired surrogate");
                  g = 65533;
                }
                d[c++] = g >> 12 | 224;
                d[c++] = g >> 6 & 63 | 128;
              }
              d[c++] = g & 63 | 128;
            }
          }
          a = d.subarray(0, c);
        }
        return a;
      }
      ;
      var Ga = {}, L2 = null;
      function Ha(a) {
        var b;
        void 0 === b && (b = 0);
        Ia();
        b = Ga[b];
        for (var c = Array(Math.floor(a.length / 3)), d = b[64] || "", e = 0, g = 0; e < a.length - 2; e += 3) {
          var f = a[e], k = a[e + 1], h = a[e + 2], l = b[f >> 2];
          f = b[(f & 3) << 4 | k >> 4];
          k = b[(k & 15) << 2 | h >> 6];
          h = b[h & 63];
          c[g++] = l + f + k + h;
        }
        l = 0;
        h = d;
        switch (a.length - e) {
          case 2:
            l = a[e + 1], h = b[(l & 15) << 2] || d;
          case 1:
            a = a[e], c[g] = b[a >> 2] + b[(a & 3) << 4 | l >> 4] + h + d;
        }
        return c.join("");
      }
      function Ja(a) {
        var b = a.length, c = 3 * b / 4;
        c % 3 ? c = Math.floor(c) : -1 != "=.".indexOf(a[b - 1]) && (c = -1 != "=.".indexOf(a[b - 2]) ? c - 2 : c - 1);
        var d = new Uint8Array(c), e = 0;
        Ka(a, function(g) {
          d[e++] = g;
        });
        return d.subarray(0, e);
      }
      function Ka(a, b) {
        function c(h) {
          for (; d < a.length; ) {
            var l = a.charAt(d++), n = L2[l];
            if (null != n)
              return n;
            if (!/^[\s\xa0]*$/.test(l))
              throw Error("Unknown base64 encoding at char: " + l);
          }
          return h;
        }
        Ia();
        for (var d = 0; ; ) {
          var e = c(-1), g = c(0), f = c(64), k = c(64);
          if (64 === k && -1 === e)
            break;
          b(e << 2 | g >> 4);
          64 != f && (b(g << 4 & 240 | f >> 2), 64 != k && b(f << 6 & 192 | k));
        }
      }
      function Ia() {
        if (!L2) {
          L2 = {};
          for (var a = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789".split(""), b = ["+/=", "+/", "-_=", "-_.", "-_"], c = 0; 5 > c; c++) {
            var d = a.concat(b[c].split(""));
            Ga[c] = d;
            for (var e = 0; e < d.length; e++) {
              var g = d[e];
              void 0 === L2[g] && (L2[g] = e);
            }
          }
        }
      }
      ;
      var La = "function" === typeof Uint8Array, Ma;
      function Na(a) {
        this.g = a;
        if (null !== a && 0 === a.length)
          throw Error("ByteString should be constructed with non-empty values");
      }
      Na.prototype.toJSON = function() {
        if (null == this.g)
          var a = "";
        else
          a = this.g, a = this.g = null == a || "string" === typeof a ? a : La && a instanceof Uint8Array ? Ha(a) : null;
        return a;
      };
      var Oa = "function" === typeof Uint8Array.prototype.slice;
      function Pa(a, b, c) {
        return b === c ? Ma || (Ma = new Uint8Array(0)) : Oa ? a.slice(b, c) : new Uint8Array(a.subarray(b, c));
      }
      var M = 0, N2 = 0;
      function Qa(a) {
        if (a.constructor === Uint8Array)
          return a;
        if (a.constructor === ArrayBuffer)
          return new Uint8Array(a);
        if (a.constructor === Array)
          return new Uint8Array(a);
        if (a.constructor === String)
          return Ja(a);
        if (a.constructor === Na) {
          if (null == a.g)
            var b = Ma || (Ma = new Uint8Array(0));
          else {
            b = Uint8Array;
            var c = a.g;
            c = null == c || La && null != c && c instanceof Uint8Array ? c : "string" === typeof c ? Ja(c) : null;
            a = a.g = c;
            b = new b(a);
          }
          return b;
        }
        if (a instanceof Uint8Array)
          return new Uint8Array(a.buffer, a.byteOffset, a.byteLength);
        throw Error("Type not convertible to a Uint8Array, expected a Uint8Array, an ArrayBuffer, a base64 encoded string, or Array of numbers");
      }
      ;
      function Ra(a, b) {
        b = void 0 === b ? {} : b;
        b = void 0 === b.u ? false : b.u;
        this.h = null;
        this.g = this.i = this.l = 0;
        this.j = false;
        this.u = b;
        a && Sa(this, a);
      }
      function Sa(a, b) {
        a.h = Qa(b);
        a.l = 0;
        a.i = a.h.length;
        a.g = a.l;
      }
      Ra.prototype.reset = function() {
        this.g = this.l;
      };
      function O(a) {
        a.g > a.i && (a.j = true, K2(Error("Tried to read past the end of the data " + a.g + " > " + a.i)));
      }
      function P(a) {
        var b = a.h, c = b[a.g], d = c & 127;
        if (128 > c)
          return a.g += 1, O(a), d;
        c = b[a.g + 1];
        d |= (c & 127) << 7;
        if (128 > c)
          return a.g += 2, O(a), d;
        c = b[a.g + 2];
        d |= (c & 127) << 14;
        if (128 > c)
          return a.g += 3, O(a), d;
        c = b[a.g + 3];
        d |= (c & 127) << 21;
        if (128 > c)
          return a.g += 4, O(a), d;
        c = b[a.g + 4];
        d |= (c & 15) << 28;
        if (128 > c)
          return a.g += 5, O(a), d >>> 0;
        a.g += 5;
        if (128 <= b[a.g++] && 128 <= b[a.g++] && 128 <= b[a.g++] && 128 <= b[a.g++] && 128 <= b[a.g++])
          return a.j = true, za(), d;
        O(a);
        return d;
      }
      var Ta = [];
      function Ua() {
        this.g = new Uint8Array(64);
        this.h = 0;
      }
      function Q2(a, b) {
        if (!(a.h + 1 < a.g.length)) {
          var c = a.g;
          a.g = new Uint8Array(Math.ceil(1 + 2 * a.g.length));
          a.g.set(c);
        }
        a.g[a.h++] = b;
      }
      Ua.prototype.length = function() {
        return this.h;
      };
      Ua.prototype.end = function() {
        var a = this.g, b = this.h;
        this.h = 0;
        return Pa(a, 0, b);
      };
      function R(a, b) {
        for (; 127 < b; )
          Q2(a, b & 127 | 128), b >>>= 7;
        Q2(a, b);
      }
      ;
      function Va(a) {
        var b = {}, c = void 0 === b.N ? false : b.N;
        this.m = { u: void 0 === b.u ? false : b.u };
        this.N = c;
        b = this.m;
        Ta.length ? (c = Ta.pop(), b && (c.u = b.u), a && Sa(c, a), a = c) : a = new Ra(a, b);
        this.g = a;
        this.l = this.g.g;
        this.h = this.i = -1;
        this.j = false;
      }
      Va.prototype.reset = function() {
        this.g.reset();
        this.h = this.i = -1;
      };
      function Wa(a) {
        var b = a.g;
        (b = b.g == b.i) || (b = a.j) || (b = a.g, b = b.j || 0 > b.g || b.g > b.i);
        if (b)
          return false;
        a.l = a.g.g;
        var c = P(a.g);
        b = c >>> 3;
        c &= 7;
        if (!(0 <= c && 5 >= c))
          return a.j = true, ya(c, a.l), false;
        a.i = b;
        a.h = c;
        return true;
      }
      function Xa(a) {
        switch (a.h) {
          case 0:
            if (0 != a.h)
              Xa(a);
            else
              a: {
                a = a.g;
                for (var b = a.g, c = 0; 10 > c; c++) {
                  if (0 === (a.h[b] & 128)) {
                    a.g = b + 1;
                    O(a);
                    break a;
                  }
                  b++;
                }
                a.j = true;
                za();
              }
            break;
          case 1:
            a = a.g;
            a.g += 8;
            O(a);
            break;
          case 2:
            2 != a.h ? Xa(a) : (b = P(a.g), a = a.g, a.g += b, O(a));
            break;
          case 5:
            a = a.g;
            a.g += 4;
            O(a);
            break;
          case 3:
            b = a.i;
            do {
              if (!Wa(a)) {
                a.j = true;
                K2(Error("Unmatched start-group tag: stream EOF"));
                break;
              }
              if (4 == a.h) {
                a.i != b && (a.j = true, K2(Error("Unmatched end-group tag")));
                break;
              }
              Xa(a);
            } while (1);
            break;
          default:
            a.j = true, ya(a.h, a.l);
        }
      }
      function Ya(a, b, c) {
        a.N || (a = Pa(a.g.h, c, a.g.g), (c = b.m) ? c.push(a) : b.m = [a]);
      }
      var Za = [];
      function $a() {
        this.h = [];
        this.i = 0;
        this.g = new Ua();
      }
      function ab(a, b) {
        0 !== b.length && (a.h.push(b), a.i += b.length);
      }
      function bb(a, b, c) {
        R(a.g, 8 * b + 2);
        R(a.g, c.length);
        ab(a, a.g.end());
        ab(a, c);
      }
      ;
      var cb = "function" === typeof Symbol && "symbol" === typeof Symbol() ? Symbol(void 0) : void 0;
      function db(a, b) {
        Object.isFrozen(a) || (cb ? a[cb] |= b : void 0 !== a.g ? a.g |= b : Object.defineProperties(a, { g: { value: b, configurable: true, writable: true, enumerable: false } }));
      }
      function eb(a) {
        if (!a)
          return 0;
        var b;
        cb ? b = a[cb] : b = a.g;
        return null == b ? 0 : b;
      }
      function fb(a) {
        if (!Array.isArray(a))
          return a;
        db(a, 1);
        return a;
      }
      function gb(a) {
        if (!Array.isArray(a))
          throw Error("cannot mark non-array as immutable");
        db(a, 2);
      }
      ;
      function hb(a) {
        return null !== a && "object" === typeof a && a.constructor === Object;
      }
      function ib(a) {
        switch (typeof a) {
          case "number":
            return isFinite(a) ? a : String(a);
          case "object":
            return La && null != a && a instanceof Uint8Array ? Ha(a) : a;
          default:
            return a;
        }
      }
      ;
      function jb(a, b) {
        if (null != a)
          return Array.isArray(a) || hb(a) ? kb(a, b) : b(a);
      }
      function kb(a, b) {
        if (Array.isArray(a)) {
          for (var c = Array(a.length), d = 0; d < a.length; d++)
            c[d] = jb(a[d], b);
          eb(a) & 1 && fb(c);
          return c;
        }
        c = {};
        for (d in a)
          c[d] = jb(a[d], b);
        return c;
      }
      ;
      var lb;
      function T(a, b, c) {
        var d = lb;
        lb = null;
        a || (a = d);
        d = this.constructor.ca;
        a || (a = d ? [d] : []);
        this.j = (d ? 0 : -1) - (this.constructor.aa || 0);
        this.i = null;
        this.g = a;
        a: {
          d = this.g.length;
          a = d - 1;
          if (d && (d = this.g[a], hb(d))) {
            this.l = a - this.j;
            this.h = d;
            break a;
          }
          void 0 !== b && -1 < b ? (this.l = Math.max(b, a + 1 - this.j), this.h = null) : this.l = Number.MAX_VALUE;
        }
        if (c)
          for (b = 0; b < c.length; b++)
            a = c[b], a < this.l ? (a += this.j, (d = this.g[a]) ? fb(d) : this.g[a] = mb) : (nb(this), (d = this.h[a]) ? fb(d) : this.h[a] = mb);
      }
      var mb = Object.freeze(fb([]));
      function nb(a) {
        var b = a.l + a.j;
        a.g[b] || (a.h = a.g[b] = {});
      }
      function U2(a, b, c) {
        return -1 === b ? null : (void 0 === c ? 0 : c) || b >= a.l ? a.h ? a.h[b] : void 0 : a.g[b + a.j];
      }
      function ob(a, b, c) {
        c = void 0 === c ? true : c;
        var d = void 0 === d ? false : d;
        var e = U2(a, b, d);
        null == e && (e = mb);
        e === mb ? (e = fb([]), V2(a, b, e, d)) : c && Array.isArray(e) && eb(e) & 2 && (e = e.slice(), V2(a, b, e, d));
        return e;
      }
      function W2(a, b, c) {
        a = U2(a, b);
        a = null == a ? a : +a;
        return null == a ? void 0 === c ? 0 : c : a;
      }
      function V2(a, b, c, d) {
        (void 0 === d ? 0 : d) || b >= a.l ? (nb(a), a.h[b] = c) : a.g[b + a.j] = c;
      }
      function pb(a, b, c) {
        a.i || (a.i = {});
        var d = a.i[c];
        if (!d) {
          var e = ob(a, c, false);
          d = [];
          for (var g = Array.isArray(e) ? !!(eb(e) & 2) : false, f = 0; f < e.length; f++)
            d[f] = new b(e[f]), g && gb(d[f].g);
          g && (gb(d), Object.freeze(d));
          a.i[c] = d;
        }
        return d;
      }
      function qb(a, b, c, d, e) {
        var g = pb(a, d, b);
        c = c ? c : new d();
        a = ob(a, b);
        void 0 != e ? (g.splice(e, 0, c), a.splice(e, 0, X2(c))) : (g.push(c), a.push(X2(c)));
      }
      T.prototype.toJSON = function() {
        var a = X2(this);
        return kb(a, ib);
      };
      function X2(a) {
        if (a.i)
          for (var b in a.i) {
            var c = a.i[b];
            if (Array.isArray(c))
              for (var d = 0; d < c.length; d++)
                c[d] && X2(c[d]);
            else
              c && X2(c);
          }
        return a.g;
      }
      T.prototype.toString = function() {
        return X2(this).toString();
      };
      function rb(a, b) {
        a = U2(a, b);
        return null == a ? 0 : a;
      }
      function sb(a, b) {
        a = U2(a, b);
        return null == a ? "" : a;
      }
      ;
      function tb(a, b) {
        if (a = a.m) {
          ab(b, b.g.end());
          for (var c = 0; c < a.length; c++)
            ab(b, a[c]);
        }
      }
      function ub(a) {
        var b = a[0];
        switch (a.length) {
          case 2:
            var c = a[1];
            return function(h, l, n) {
              return b(h, l, n, c);
            };
          case 3:
            var d = a[1], e = a[2];
            return function(h, l, n) {
              return b(h, l, n, d, e);
            };
          case 4:
            var g = a[1], f = a[2], k = a[3];
            return function(h, l, n) {
              return b(h, l, n, g, f, k);
            };
          default:
            throw Error("unsupported number of parameters, expected [2-4], got " + a.length);
        }
      }
      function vb(a, b, c) {
        for (; Wa(b) && 4 != b.h; ) {
          var d = b.i, e = c[d];
          if (e) {
            if (Array.isArray(e) && (e = c[d] = ub(e)), !e(b, a, d)) {
              d = b;
              e = a;
              var g = d.l;
              Xa(d);
              Ya(d, e, g);
            }
          } else
            d = b, e = a, g = d.l, Xa(d), Ya(d, e, g);
        }
        return a;
      }
      function wb(a, b) {
        var c = new $a();
        b(a, c);
        a = c.i + c.g.length();
        if (0 === a)
          c = new Uint8Array(0);
        else {
          a = new Uint8Array(a);
          for (var d = c.h, e = d.length, g = b = 0; g < e; g++) {
            var f = d[g];
            0 !== f.length && (a.set(f, b), b += f.length);
          }
          d = c.g;
          e = d.h;
          0 !== e && (a.set(d.g.subarray(0, e), b), d.h = 0);
          c.h = [a];
          c = a;
        }
        return c;
      }
      function xb(a, b, c) {
        if (Za.length) {
          var d = Za.pop();
          a && (Sa(d.g, a), d.i = -1, d.h = -1);
          a = d;
        } else
          a = new Va(a);
        try {
          return c(new b(), a);
        } finally {
          b = a.g, b.h = null, b.l = 0, b.i = 0, b.g = 0, b.j = false, b.u = false, a.i = -1, a.h = -1, a.j = false, 100 > Za.length && Za.push(a);
        }
      }
      function Y2(a, b, c) {
        b = U2(b, c);
        if (null != b) {
          R(a.g, 8 * c + 5);
          a = a.g;
          var d = b;
          d = (c = 0 > d ? 1 : 0) ? -d : d;
          0 === d ? 0 < 1 / d ? M = N2 = 0 : (N2 = 0, M = 2147483648) : isNaN(d) ? (N2 = 0, M = 2147483647) : 34028234663852886e22 < d ? (N2 = 0, M = (c << 31 | 2139095040) >>> 0) : 11754943508222875e-54 > d ? (d = Math.round(d / Math.pow(2, -149)), N2 = 0, M = (c << 31 | d) >>> 0) : (b = Math.floor(Math.log(d) / Math.LN2), d *= Math.pow(2, -b), d = Math.round(8388608 * d), 16777216 <= d && ++b, N2 = 0, M = (c << 31 | b + 127 << 23 | d & 8388607) >>> 0);
          c = M;
          Q2(a, c >>> 0 & 255);
          Q2(a, c >>> 8 & 255);
          Q2(a, c >>> 16 & 255);
          Q2(a, c >>> 24 & 255);
        }
      }
      function Z2(a, b, c) {
        if (5 !== a.h)
          return false;
        a = a.g;
        var d = a.h[a.g];
        var e = a.h[a.g + 1];
        var g = a.h[a.g + 2], f = a.h[a.g + 3];
        a.g += 4;
        O(a);
        e = (d << 0 | e << 8 | g << 16 | f << 24) >>> 0;
        a = 2 * (e >> 31) + 1;
        d = e >>> 23 & 255;
        e &= 8388607;
        V2(b, c, 255 == d ? e ? NaN : Infinity * a : 0 == d ? a * Math.pow(2, -149) * e : a * Math.pow(2, d - 150) * (e + Math.pow(2, 23)));
        return true;
      }
      function yb(a, b, c) {
        if (0 !== a.h)
          return false;
        for (var d = a.g, e = 128, g = 0, f = a = 0; 4 > f && 128 <= e; f++)
          e = d.h[d.g++], g |= (e & 127) << 7 * f;
        128 <= e && (e = d.h[d.g++], g |= (e & 127) << 28, a |= (e & 127) >> 4);
        if (128 <= e)
          for (f = 0; 5 > f && 128 <= e; f++)
            e = d.h[d.g++], a |= (e & 127) << 7 * f + 3;
        if (128 > e) {
          d = g >>> 0;
          e = a >>> 0;
          if (a = e & 2147483648)
            d = ~d + 1 >>> 0, e = ~e >>> 0, 0 == d && (e = e + 1 >>> 0);
          d = 4294967296 * e + (d >>> 0);
          a = a ? -d : d;
        } else
          d.j = true, za(), a = void 0;
        V2(b, c, a);
        return true;
      }
      function zb(a, b, c) {
        if (0 !== a.h)
          return false;
        V2(b, c, P(a.g));
        return true;
      }
      function Ab(a, b, c) {
        if (2 !== a.h)
          return false;
        var d = P(a.g);
        a = a.g;
        var e = a.g;
        a.g += d;
        O(a);
        a = a.h;
        var g;
        if (Ca)
          (g = Ba) || (g = Ba = new TextDecoder("utf-8", { fatal: false })), g = g.decode(a.subarray(e, e + d));
        else {
          d = e + d;
          for (var f = [], k = null, h, l, n; e < d; )
            h = a[e++], 128 > h ? f.push(h) : 224 > h ? e >= d ? f.push(65533) : (l = a[e++], 194 > h || 128 !== (l & 192) ? (e--, f.push(65533)) : f.push((h & 31) << 6 | l & 63)) : 240 > h ? e >= d - 1 ? f.push(65533) : (l = a[e++], 128 !== (l & 192) || 224 === h && 160 > l || 237 === h && 160 <= l || 128 !== ((g = a[e++]) & 192) ? (e--, f.push(65533)) : f.push((h & 15) << 12 | (l & 63) << 6 | g & 63)) : 244 >= h ? e >= d - 2 ? f.push(65533) : (l = a[e++], 128 !== (l & 192) || 0 !== (h << 28) + (l - 144) >> 30 || 128 !== ((g = a[e++]) & 192) || 128 !== ((n = a[e++]) & 192) ? (e--, f.push(65533)) : (h = (h & 7) << 18 | (l & 63) << 12 | (g & 63) << 6 | n & 63, h -= 65536, f.push((h >> 10 & 1023) + 55296, (h & 1023) + 56320))) : f.push(65533), 8192 <= f.length && (k = Aa(k, f), f.length = 0);
          g = Aa(k, f);
        }
        V2(b, c, g);
        return true;
      }
      function Bb(a, b, c, d, e) {
        if (2 !== a.h)
          return false;
        var g = new d(), f = a.g.i, k = P(a.g), h = a.g.g + k;
        a.g.i = h;
        e(g, a);
        e = h - a.g.g;
        if (0 !== e)
          throw Error("Message parsing ended unexpectedly. Expected to read " + (k + " bytes, instead read " + (k - e) + " bytes, either the data ended unexpectedly or the message misreported its own length"));
        a.g.g = h;
        a.g.i = f;
        qb(b, c, g, d, void 0);
        return true;
      }
      ;
      function Cb(a) {
        T.call(this, a);
      }
      var Db;
      E2(Cb, T);
      function Eb(a, b) {
        var c = U2(a, 1);
        if (null != c && null != c) {
          R(b.g, 8);
          var d = b.g;
          if (0 <= c)
            R(d, c);
          else {
            for (var e = 0; 9 > e; e++)
              Q2(d, c & 127 | 128), c >>= 7;
            Q2(d, 1);
          }
        }
        Y2(b, a, 2);
        d = U2(a, 3);
        null != d && bb(b, 3, Fa(d));
        d = U2(a, 4);
        null != d && bb(b, 4, Fa(d));
        tb(a, b);
      }
      function Fb(a, b) {
        return vb(a, b, Db || (Db = { 1: zb, 2: Z2, 3: Ab, 4: Ab }));
      }
      ;
      function Gb(a) {
        T.call(this, a, -1, Hb);
      }
      var Ib;
      E2(Gb, T);
      Gb.prototype.addClassification = function(a, b) {
        qb(this, 1, a, Cb, b);
        return this;
      };
      function Jb(a, b) {
        return vb(a, b, Ib || (Ib = { 1: [Bb, Cb, Fb] }));
      }
      var Hb = [1];
      function Kb(a) {
        T.call(this, a);
      }
      var Lb;
      E2(Kb, T);
      function Mb(a, b) {
        Y2(b, a, 1);
        Y2(b, a, 2);
        Y2(b, a, 3);
        Y2(b, a, 4);
        Y2(b, a, 5);
        tb(a, b);
      }
      function Nb(a, b) {
        return vb(a, b, Lb || (Lb = { 1: Z2, 2: Z2, 3: Z2, 4: Z2, 5: Z2 }));
      }
      ;
      function Ob(a) {
        T.call(this, a, -1, Pb);
      }
      var Qb;
      E2(Ob, T);
      function Rb(a, b) {
        return vb(a, b, Qb || (Qb = { 1: [Bb, Kb, Nb] }));
      }
      var Pb = [1];
      function Sb(a) {
        T.call(this, a);
      }
      var Tb;
      E2(Sb, T);
      function Ub(a, b) {
        Y2(b, a, 1);
        Y2(b, a, 2);
        Y2(b, a, 3);
        Y2(b, a, 4);
        Y2(b, a, 5);
        var c = U2(a, 6);
        if (null != c && null != c) {
          R(b.g, 48);
          var d = b.g, e = c;
          c = 0 > e;
          e = Math.abs(e);
          var g = e >>> 0;
          e = Math.floor((e - g) / 4294967296);
          e >>>= 0;
          c && (e = ~e >>> 0, g = (~g >>> 0) + 1, 4294967295 < g && (g = 0, e++, 4294967295 < e && (e = 0)));
          M = g;
          N2 = e;
          c = M;
          for (g = N2; 0 < g || 127 < c; )
            Q2(d, c & 127 | 128), c = (c >>> 7 | g << 25) >>> 0, g >>>= 7;
          Q2(d, c);
        }
        tb(a, b);
      }
      function Vb(a, b) {
        return vb(a, b, Tb || (Tb = { 1: Z2, 2: Z2, 3: Z2, 4: Z2, 5: Z2, 6: yb }));
      }
      ;
      function Wb(a, b, c) {
        c = a.createShader(0 === c ? a.VERTEX_SHADER : a.FRAGMENT_SHADER);
        a.shaderSource(c, b);
        a.compileShader(c);
        if (!a.getShaderParameter(c, a.COMPILE_STATUS))
          throw Error("Could not compile WebGL shader.\n\n" + a.getShaderInfoLog(c));
        return c;
      }
      ;
      function Xb(a) {
        return pb(a, Cb, 1).map(function(b) {
          return { index: rb(b, 1), X: W2(b, 2), label: null != U2(b, 3) ? sb(b, 3) : void 0, displayName: null != U2(b, 4) ? sb(b, 4) : void 0 };
        });
      }
      ;
      function Yb(a) {
        return { x: W2(a, 1), y: W2(a, 2), z: W2(a, 3), visibility: null != U2(a, 4) ? W2(a, 4) : void 0 };
      }
      function Zb(a) {
        return pb(xb(a, Ob, Rb), Kb, 1).map(Yb);
      }
      ;
      function $b(a, b) {
        this.h = a;
        this.g = b;
        this.l = 0;
      }
      function ac(a, b, c) {
        bc(a, b);
        if ("function" === typeof a.g.canvas.transferToImageBitmap)
          return Promise.resolve(a.g.canvas.transferToImageBitmap());
        if (c)
          return Promise.resolve(a.g.canvas);
        if ("function" === typeof createImageBitmap)
          return createImageBitmap(a.g.canvas);
        void 0 === a.i && (a.i = document.createElement("canvas"));
        return new Promise(function(d) {
          a.i.height = a.g.canvas.height;
          a.i.width = a.g.canvas.width;
          a.i.getContext("2d", {}).drawImage(a.g.canvas, 0, 0, a.g.canvas.width, a.g.canvas.height);
          d(a.i);
        });
      }
      function bc(a, b) {
        var c = a.g;
        if (void 0 === a.m) {
          var d = Wb(c, "\n  attribute vec2 aVertex;\n  attribute vec2 aTex;\n  varying vec2 vTex;\n  void main(void) {\n    gl_Position = vec4(aVertex, 0.0, 1.0);\n    vTex = aTex;\n  }", 0), e = Wb(c, "\n  precision mediump float;\n  varying vec2 vTex;\n  uniform sampler2D sampler0;\n  void main(){\n    gl_FragColor = texture2D(sampler0, vTex);\n  }", 1), g = c.createProgram();
          c.attachShader(g, d);
          c.attachShader(g, e);
          c.linkProgram(g);
          if (!c.getProgramParameter(g, c.LINK_STATUS))
            throw Error("Could not compile WebGL program.\n\n" + c.getProgramInfoLog(g));
          d = a.m = g;
          c.useProgram(d);
          e = c.getUniformLocation(d, "sampler0");
          a.j = { I: c.getAttribLocation(d, "aVertex"), H: c.getAttribLocation(d, "aTex"), da: e };
          a.s = c.createBuffer();
          c.bindBuffer(c.ARRAY_BUFFER, a.s);
          c.enableVertexAttribArray(a.j.I);
          c.vertexAttribPointer(a.j.I, 2, c.FLOAT, false, 0, 0);
          c.bufferData(c.ARRAY_BUFFER, new Float32Array([-1, -1, -1, 1, 1, 1, 1, -1]), c.STATIC_DRAW);
          c.bindBuffer(c.ARRAY_BUFFER, null);
          a.o = c.createBuffer();
          c.bindBuffer(c.ARRAY_BUFFER, a.o);
          c.enableVertexAttribArray(a.j.H);
          c.vertexAttribPointer(
            a.j.H,
            2,
            c.FLOAT,
            false,
            0,
            0
          );
          c.bufferData(c.ARRAY_BUFFER, new Float32Array([0, 1, 0, 0, 1, 0, 1, 1]), c.STATIC_DRAW);
          c.bindBuffer(c.ARRAY_BUFFER, null);
          c.uniform1i(e, 0);
        }
        d = a.j;
        c.useProgram(a.m);
        c.canvas.width = b.width;
        c.canvas.height = b.height;
        c.viewport(0, 0, b.width, b.height);
        c.activeTexture(c.TEXTURE0);
        a.h.bindTexture2d(b.glName);
        c.enableVertexAttribArray(d.I);
        c.bindBuffer(c.ARRAY_BUFFER, a.s);
        c.vertexAttribPointer(d.I, 2, c.FLOAT, false, 0, 0);
        c.enableVertexAttribArray(d.H);
        c.bindBuffer(c.ARRAY_BUFFER, a.o);
        c.vertexAttribPointer(
          d.H,
          2,
          c.FLOAT,
          false,
          0,
          0
        );
        c.bindFramebuffer(c.DRAW_FRAMEBUFFER ? c.DRAW_FRAMEBUFFER : c.FRAMEBUFFER, null);
        c.clearColor(0, 0, 0, 0);
        c.clear(c.COLOR_BUFFER_BIT);
        c.colorMask(true, true, true, true);
        c.drawArrays(c.TRIANGLE_FAN, 0, 4);
        c.disableVertexAttribArray(d.I);
        c.disableVertexAttribArray(d.H);
        c.bindBuffer(c.ARRAY_BUFFER, null);
        a.h.bindTexture2d(0);
      }
      function cc(a) {
        this.g = a;
      }
      ;
      var dc = new Uint8Array([0, 97, 115, 109, 1, 0, 0, 0, 1, 4, 1, 96, 0, 0, 3, 2, 1, 0, 10, 9, 1, 7, 0, 65, 0, 253, 15, 26, 11]);
      function ec(a, b) {
        return b + a;
      }
      function fc(a, b) {
        window[a] = b;
      }
      function gc(a) {
        var b = document.createElement("script");
        b.setAttribute("src", a);
        b.setAttribute("crossorigin", "anonymous");
        return new Promise(function(c) {
          b.addEventListener("load", function() {
            c();
          }, false);
          b.addEventListener("error", function() {
            c();
          }, false);
          document.body.appendChild(b);
        });
      }
      function hc() {
        return H2(function(a) {
          switch (a.g) {
            case 1:
              return a.m = 2, F(a, WebAssembly.instantiate(dc), 4);
            case 4:
              a.g = 3;
              a.m = 0;
              break;
            case 2:
              return a.m = 0, a.j = null, a.return(false);
            case 3:
              return a.return(true);
          }
        });
      }
      function ic(a) {
        this.g = a;
        this.listeners = {};
        this.j = {};
        this.F = {};
        this.m = {};
        this.s = {};
        this.G = this.o = this.R = true;
        this.C = Promise.resolve();
        this.P = "";
        this.B = {};
        this.locateFile = a && a.locateFile || ec;
        if ("object" === typeof window)
          var b = window.location.pathname.toString().substring(0, window.location.pathname.toString().lastIndexOf("/")) + "/";
        else if ("undefined" !== typeof location)
          b = location.pathname.toString().substring(0, location.pathname.toString().lastIndexOf("/")) + "/";
        else
          throw Error("solutions can only be loaded on a web page or in a web worker");
        this.S = b;
        if (a.options) {
          b = C(Object.keys(a.options));
          for (var c = b.next(); !c.done; c = b.next()) {
            c = c.value;
            var d = a.options[c].default;
            void 0 !== d && (this.j[c] = "function" === typeof d ? d() : d);
          }
        }
      }
      x = ic.prototype;
      x.close = function() {
        this.i && this.i.delete();
        return Promise.resolve();
      };
      function jc(a) {
        var b, c, d, e, g, f, k, h, l, n, r;
        return H2(function(p) {
          switch (p.g) {
            case 1:
              if (!a.R)
                return p.return();
              b = void 0 === a.g.files ? [] : "function" === typeof a.g.files ? a.g.files(a.j) : a.g.files;
              return F(p, hc(), 2);
            case 2:
              c = p.h;
              if ("object" === typeof window)
                return fc("createMediapipeSolutionsWasm", { locateFile: a.locateFile }), fc("createMediapipeSolutionsPackedAssets", { locateFile: a.locateFile }), f = b.filter(function(m) {
                  return void 0 !== m.data;
                }), k = b.filter(function(m) {
                  return void 0 === m.data;
                }), h = Promise.all(f.map(function(m) {
                  var q2 = kc(a, m.url);
                  if (void 0 !== m.path) {
                    var t2 = m.path;
                    q2 = q2.then(function(w) {
                      a.overrideFile(t2, w);
                      return Promise.resolve(w);
                    });
                  }
                  return q2;
                })), l = Promise.all(k.map(function(m) {
                  return void 0 === m.simd || m.simd && c || !m.simd && !c ? gc(a.locateFile(m.url, a.S)) : Promise.resolve();
                })).then(function() {
                  var m, q2, t2;
                  return H2(function(w) {
                    if (1 == w.g)
                      return m = window.createMediapipeSolutionsWasm, q2 = window.createMediapipeSolutionsPackedAssets, t2 = a, F(w, m(q2), 2);
                    t2.h = w.h;
                    w.g = 0;
                  });
                }), n = function() {
                  return H2(function(m) {
                    a.g.graph && a.g.graph.url ? m = F(
                      m,
                      kc(a, a.g.graph.url),
                      0
                    ) : (m.g = 0, m = void 0);
                    return m;
                  });
                }(), F(p, Promise.all([l, h, n]), 7);
              if ("function" !== typeof importScripts)
                throw Error("solutions can only be loaded on a web page or in a web worker");
              d = b.filter(function(m) {
                return void 0 === m.simd || m.simd && c || !m.simd && !c;
              }).map(function(m) {
                return a.locateFile(m.url, a.S);
              });
              importScripts.apply(null, ea(d));
              e = a;
              return F(p, createMediapipeSolutionsWasm(Module), 6);
            case 6:
              e.h = p.h;
              a.l = new OffscreenCanvas(1, 1);
              a.h.canvas = a.l;
              g = a.h.GL.createContext(a.l, {
                antialias: false,
                alpha: false,
                ba: "undefined" !== typeof WebGL2RenderingContext ? 2 : 1
              });
              a.h.GL.makeContextCurrent(g);
              p.g = 4;
              break;
            case 7:
              a.l = document.createElement("canvas");
              r = a.l.getContext("webgl2", {});
              if (!r && (r = a.l.getContext("webgl", {}), !r))
                return alert("Failed to create WebGL canvas context when passing video frame."), p.return();
              a.D = r;
              a.h.canvas = a.l;
              a.h.createContext(a.l, true, true, {});
            case 4:
              a.i = new a.h.SolutionWasm(), a.R = false, p.g = 0;
          }
        });
      }
      function lc(a) {
        var b, c, d, e, g, f, k, h;
        return H2(function(l) {
          if (1 == l.g) {
            if (a.g.graph && a.g.graph.url && a.P === a.g.graph.url)
              return l.return();
            a.o = true;
            if (!a.g.graph || !a.g.graph.url) {
              l.g = 2;
              return;
            }
            a.P = a.g.graph.url;
            return F(l, kc(a, a.g.graph.url), 3);
          }
          2 != l.g && (b = l.h, a.i.loadGraph(b));
          c = C(Object.keys(a.B));
          for (d = c.next(); !d.done; d = c.next())
            e = d.value, a.i.overrideFile(e, a.B[e]);
          a.B = {};
          if (a.g.listeners)
            for (g = C(a.g.listeners), f = g.next(); !f.done; f = g.next())
              k = f.value, mc(a, k);
          h = a.j;
          a.j = {};
          a.setOptions(h);
          l.g = 0;
        });
      }
      x.reset = function() {
        var a = this;
        return H2(function(b) {
          a.i && (a.i.reset(), a.m = {}, a.s = {});
          b.g = 0;
        });
      };
      x.setOptions = function(a, b) {
        var c = this;
        if (b = b || this.g.options) {
          for (var d = [], e = [], g = {}, f = C(Object.keys(a)), k = f.next(); !k.done; g = { K: g.K, L: g.L }, k = f.next()) {
            var h = k.value;
            h in this.j && this.j[h] === a[h] || (this.j[h] = a[h], k = b[h], void 0 !== k && (k.onChange && (g.K = k.onChange, g.L = a[h], d.push(function(l) {
              return function() {
                var n;
                return H2(function(r) {
                  if (1 == r.g)
                    return F(r, l.K(l.L), 2);
                  n = r.h;
                  true === n && (c.o = true);
                  r.g = 0;
                });
              };
            }(g))), k.graphOptionXref && (h = { valueNumber: 1 === k.type ? a[h] : 0, valueBoolean: 0 === k.type ? a[h] : false, valueString: 2 === k.type ? a[h] : "" }, k = Object.assign(Object.assign(Object.assign({}, { calculatorName: "", calculatorIndex: 0 }), k.graphOptionXref), h), e.push(k))));
          }
          if (0 !== d.length || 0 !== e.length)
            this.o = true, this.A = (void 0 === this.A ? [] : this.A).concat(e), this.v = (void 0 === this.v ? [] : this.v).concat(d);
        }
      };
      function nc(a) {
        var b, c, d, e, g, f, k;
        return H2(function(h) {
          switch (h.g) {
            case 1:
              if (!a.o)
                return h.return();
              if (!a.v) {
                h.g = 2;
                break;
              }
              b = C(a.v);
              c = b.next();
            case 3:
              if (c.done) {
                h.g = 5;
                break;
              }
              d = c.value;
              return F(h, d(), 4);
            case 4:
              c = b.next();
              h.g = 3;
              break;
            case 5:
              a.v = void 0;
            case 2:
              if (a.A) {
                e = new a.h.GraphOptionChangeRequestList();
                g = C(a.A);
                for (f = g.next(); !f.done; f = g.next())
                  k = f.value, e.push_back(k);
                a.i.changeOptions(e);
                e.delete();
                a.A = void 0;
              }
              a.o = false;
              h.g = 0;
          }
        });
      }
      x.initialize = function() {
        var a = this;
        return H2(function(b) {
          return 1 == b.g ? F(b, jc(a), 2) : 3 != b.g ? F(b, lc(a), 3) : F(b, nc(a), 0);
        });
      };
      function kc(a, b) {
        var c, d;
        return H2(function(e) {
          if (b in a.F)
            return e.return(a.F[b]);
          c = a.locateFile(b, "");
          d = fetch(c).then(function(g) {
            return g.arrayBuffer();
          });
          a.F[b] = d;
          return e.return(d);
        });
      }
      x.overrideFile = function(a, b) {
        this.i ? this.i.overrideFile(a, b) : this.B[a] = b;
      };
      x.clearOverriddenFiles = function() {
        this.B = {};
        this.i && this.i.clearOverriddenFiles();
      };
      x.send = function(a, b) {
        var c = this, d, e, g, f, k, h, l, n, r;
        return H2(function(p) {
          switch (p.g) {
            case 1:
              if (!c.g.inputs)
                return p.return();
              d = 1e3 * (void 0 === b || null === b ? performance.now() : b);
              return F(p, c.C, 2);
            case 2:
              return F(p, c.initialize(), 3);
            case 3:
              e = new c.h.PacketDataList();
              g = C(Object.keys(a));
              for (f = g.next(); !f.done; f = g.next())
                if (k = f.value, h = c.g.inputs[k]) {
                  a: {
                    var m = a[k];
                    switch (h.type) {
                      case "video":
                        var q2 = c.m[h.stream];
                        q2 || (q2 = new $b(c.h, c.D), c.m[h.stream] = q2);
                        0 === q2.l && (q2.l = q2.h.createTexture());
                        if ("undefined" !== typeof HTMLVideoElement && m instanceof HTMLVideoElement) {
                          var t2 = m.videoWidth;
                          var w = m.videoHeight;
                        } else
                          "undefined" !== typeof HTMLImageElement && m instanceof HTMLImageElement ? (t2 = m.naturalWidth, w = m.naturalHeight) : (t2 = m.width, w = m.height);
                        w = { glName: q2.l, width: t2, height: w };
                        t2 = q2.g;
                        t2.canvas.width = w.width;
                        t2.canvas.height = w.height;
                        t2.activeTexture(t2.TEXTURE0);
                        q2.h.bindTexture2d(q2.l);
                        t2.texImage2D(t2.TEXTURE_2D, 0, t2.RGBA, t2.RGBA, t2.UNSIGNED_BYTE, m);
                        q2.h.bindTexture2d(0);
                        q2 = w;
                        break a;
                      case "detections":
                        q2 = c.m[h.stream];
                        q2 || (q2 = new cc(c.h), c.m[h.stream] = q2);
                        q2.data || (q2.data = new q2.g.DetectionListData());
                        q2.data.reset(m.length);
                        for (w = 0; w < m.length; ++w) {
                          t2 = m[w];
                          var v = q2.data, A = v.setBoundingBox, I = w;
                          var D2 = t2.T;
                          var u = new Sb();
                          V2(u, 1, D2.Y);
                          V2(u, 2, D2.Z);
                          V2(u, 3, D2.height);
                          V2(u, 4, D2.width);
                          V2(u, 5, D2.rotation);
                          V2(u, 6, D2.W);
                          D2 = wb(u, Ub);
                          A.call(v, I, D2);
                          if (t2.O)
                            for (v = 0; v < t2.O.length; ++v) {
                              u = t2.O[v];
                              var z2 = u.visibility ? true : false;
                              A = q2.data;
                              I = A.addNormalizedLandmark;
                              D2 = w;
                              u = Object.assign(Object.assign({}, u), { visibility: z2 ? u.visibility : 0 });
                              z2 = new Kb();
                              V2(z2, 1, u.x);
                              V2(z2, 2, u.y);
                              V2(z2, 3, u.z);
                              u.visibility && V2(z2, 4, u.visibility);
                              u = wb(z2, Mb);
                              I.call(A, D2, u);
                            }
                          if (t2.M)
                            for (v = 0; v < t2.M.length; ++v)
                              A = q2.data, I = A.addClassification, D2 = w, u = t2.M[v], z2 = new Cb(), V2(z2, 2, u.X), u.index && V2(z2, 1, u.index), u.label && V2(z2, 3, u.label), u.displayName && V2(z2, 4, u.displayName), u = wb(z2, Eb), I.call(A, D2, u);
                        }
                        q2 = q2.data;
                        break a;
                      default:
                        q2 = {};
                    }
                  }
                  l = q2;
                  n = h.stream;
                  switch (h.type) {
                    case "video":
                      e.pushTexture2d(Object.assign(Object.assign({}, l), { stream: n, timestamp: d }));
                      break;
                    case "detections":
                      r = l;
                      r.stream = n;
                      r.timestamp = d;
                      e.pushDetectionList(r);
                      break;
                    default:
                      throw Error("Unknown input config type: '" + h.type + "'");
                  }
                }
              c.i.send(e);
              return F(p, c.C, 4);
            case 4:
              e.delete(), p.g = 0;
          }
        });
      };
      function oc(a, b, c) {
        var d, e, g, f, k, h, l, n, r, p, m, q2, t2, w;
        return H2(function(v) {
          switch (v.g) {
            case 1:
              if (!c)
                return v.return(b);
              d = {};
              e = 0;
              g = C(Object.keys(c));
              for (f = g.next(); !f.done; f = g.next())
                k = f.value, h = c[k], "string" !== typeof h && "texture" === h.type && void 0 !== b[h.stream] && ++e;
              1 < e && (a.G = false);
              l = C(Object.keys(c));
              f = l.next();
            case 2:
              if (f.done) {
                v.g = 4;
                break;
              }
              n = f.value;
              r = c[n];
              if ("string" === typeof r)
                return t2 = d, w = n, F(v, pc(a, n, b[r]), 14);
              p = b[r.stream];
              if ("detection_list" === r.type) {
                if (p) {
                  var A = p.getRectList();
                  for (var I = p.getLandmarksList(), D2 = p.getClassificationsList(), u = [], z2 = 0; z2 < A.size(); ++z2) {
                    var S = xb(A.get(z2), Sb, Vb);
                    S = { T: { Y: W2(S, 1), Z: W2(S, 2), height: W2(S, 3), width: W2(S, 4), rotation: W2(S, 5, 0), W: rb(S, 6) }, O: Zb(I.get(z2)), M: Xb(xb(D2.get(z2), Gb, Jb)) };
                    u.push(S);
                  }
                  A = u;
                } else
                  A = [];
                d[n] = A;
                v.g = 7;
                break;
              }
              if ("proto_list" === r.type) {
                if (p) {
                  A = Array(p.size());
                  for (I = 0; I < p.size(); I++)
                    A[I] = p.get(I);
                  p.delete();
                } else
                  A = [];
                d[n] = A;
                v.g = 7;
                break;
              }
              if (void 0 === p) {
                v.g = 3;
                break;
              }
              if ("float_list" === r.type) {
                d[n] = p;
                v.g = 7;
                break;
              }
              if ("proto" === r.type) {
                d[n] = p;
                v.g = 7;
                break;
              }
              if ("texture" !== r.type)
                throw Error("Unknown output config type: '" + r.type + "'");
              m = a.s[n];
              m || (m = new $b(a.h, a.D), a.s[n] = m);
              return F(v, ac(m, p, a.G), 13);
            case 13:
              q2 = v.h, d[n] = q2;
            case 7:
              r.transform && d[n] && (d[n] = r.transform(d[n]));
              v.g = 3;
              break;
            case 14:
              t2[w] = v.h;
            case 3:
              f = l.next();
              v.g = 2;
              break;
            case 4:
              return v.return(d);
          }
        });
      }
      function pc(a, b, c) {
        var d;
        return H2(function(e) {
          return "number" === typeof c || c instanceof Uint8Array || c instanceof a.h.Uint8BlobList ? e.return(c) : c instanceof a.h.Texture2dDataOut ? (d = a.s[b], d || (d = new $b(a.h, a.D), a.s[b] = d), e.return(ac(d, c, a.G))) : e.return(void 0);
        });
      }
      function mc(a, b) {
        for (var c = b.name || "$", d = [].concat(ea(b.wants)), e = new a.h.StringList(), g = C(b.wants), f = g.next(); !f.done; f = g.next())
          e.push_back(f.value);
        g = a.h.PacketListener.implement({ onResults: function(k) {
          for (var h = {}, l = 0; l < b.wants.length; ++l)
            h[d[l]] = k.get(l);
          var n = a.listeners[c];
          n && (a.C = oc(a, h, b.outs).then(function(r) {
            r = n(r);
            for (var p = 0; p < b.wants.length; ++p) {
              var m = h[d[p]];
              "object" === typeof m && m.hasOwnProperty && m.hasOwnProperty("delete") && m.delete();
            }
            r && (a.C = r);
          }));
        } });
        a.i.attachMultiListener(e, g);
        e.delete();
      }
      x.onResults = function(a, b) {
        this.listeners[b || "$"] = a;
      };
      J2("Solution", ic);
      J2("OptionType", { BOOL: 0, NUMBER: 1, $: 2, 0: "BOOL", 1: "NUMBER", 2: "STRING" });
      function qc(a) {
        void 0 === a && (a = 0);
        switch (a) {
          case 1:
            return "pose_landmark_full.tflite";
          case 2:
            return "pose_landmark_heavy.tflite";
          default:
            return "pose_landmark_lite.tflite";
        }
      }
      function rc(a) {
        var b = this;
        a = a || {};
        this.g = new ic({ locateFile: a.locateFile, files: function(c) {
          return [{ url: "pose_solution_packed_assets_loader.js" }, { simd: false, url: "pose_solution_wasm_bin.js" }, { simd: true, url: "pose_solution_simd_wasm_bin.js" }, { data: true, url: qc(c.modelComplexity) }];
        }, graph: { url: "pose_web.binarypb" }, listeners: [{ wants: ["pose_landmarks", "world_landmarks", "segmentation_mask", "image_transformed"], outs: { image: { type: "texture", stream: "image_transformed" }, poseLandmarks: {
          type: "proto",
          stream: "pose_landmarks",
          transform: Zb
        }, poseWorldLandmarks: { type: "proto", stream: "world_landmarks", transform: Zb }, segmentationMask: { type: "texture", stream: "segmentation_mask" } } }], inputs: { image: { type: "video", stream: "input_frames_gpu" } }, options: {
          useCpuInference: { type: 0, graphOptionXref: { calculatorType: "InferenceCalculator", fieldName: "use_cpu_inference" }, default: "iPad Simulator;iPhone Simulator;iPod Simulator;iPad;iPhone;iPod".split(";").includes(navigator.platform) || navigator.userAgent.includes("Mac") && "ontouchend" in document },
          selfieMode: { type: 0, graphOptionXref: { calculatorType: "GlScalerCalculator", calculatorIndex: 1, fieldName: "flip_horizontal" } },
          modelComplexity: { type: 1, graphOptionXref: { calculatorType: "ConstantSidePacketCalculator", calculatorName: "ConstantSidePacketCalculatorModelComplexity", fieldName: "int_value" }, onChange: function(c) {
            var d, e, g;
            return H2(function(f) {
              if (1 == f.g)
                return d = qc(c), e = "third_party/mediapipe/modules/pose_landmark/" + d, F(f, kc(b.g, d), 2);
              g = f.h;
              b.g.overrideFile(e, g);
              return f.return(true);
            });
          } },
          smoothLandmarks: {
            type: 0,
            graphOptionXref: { calculatorType: "ConstantSidePacketCalculator", calculatorName: "ConstantSidePacketCalculatorSmoothLandmarks", fieldName: "bool_value" }
          },
          enableSegmentation: { type: 0, graphOptionXref: { calculatorType: "ConstantSidePacketCalculator", calculatorName: "ConstantSidePacketCalculatorEnableSegmentation", fieldName: "bool_value" } },
          smoothSegmentation: { type: 0, graphOptionXref: { calculatorType: "ConstantSidePacketCalculator", calculatorName: "ConstantSidePacketCalculatorSmoothSegmentation", fieldName: "bool_value" } },
          minDetectionConfidence: { type: 1, graphOptionXref: { calculatorType: "TensorsToDetectionsCalculator", calculatorName: "poselandmarkgpu__posedetectiongpu__TensorsToDetectionsCalculator", fieldName: "min_score_thresh" } },
          minTrackingConfidence: { type: 1, graphOptionXref: { calculatorType: "ThresholdingCalculator", calculatorName: "poselandmarkgpu__poselandmarkbyroigpu__tensorstoposelandmarksandsegmentation__ThresholdingCalculator", fieldName: "threshold" } }
        } });
      }
      x = rc.prototype;
      x.reset = function() {
        this.g.reset();
      };
      x.close = function() {
        this.g.close();
        return Promise.resolve();
      };
      x.onResults = function(a) {
        this.g.onResults(a);
      };
      x.initialize = function() {
        var a = this;
        return H2(function(b) {
          return F(b, a.g.initialize(), 0);
        });
      };
      x.send = function(a, b) {
        var c = this;
        return H2(function(d) {
          return F(d, c.g.send(a, b), 0);
        });
      };
      x.setOptions = function(a) {
        this.g.setOptions(a);
      };
      J2("Pose", rc);
      J2("POSE_CONNECTIONS", [[0, 1], [1, 2], [2, 3], [3, 7], [0, 4], [4, 5], [5, 6], [6, 8], [9, 10], [11, 12], [11, 13], [13, 15], [15, 17], [15, 19], [15, 21], [17, 19], [12, 14], [14, 16], [16, 18], [16, 20], [16, 22], [18, 20], [11, 23], [12, 24], [23, 24], [23, 25], [24, 26], [25, 27], [26, 28], [27, 29], [28, 30], [29, 31], [30, 32], [27, 31], [28, 32]]);
      J2("POSE_LANDMARKS", { NOSE: 0, LEFT_EYE_INNER: 1, LEFT_EYE: 2, LEFT_EYE_OUTER: 3, RIGHT_EYE_INNER: 4, RIGHT_EYE: 5, RIGHT_EYE_OUTER: 6, LEFT_EAR: 7, RIGHT_EAR: 8, LEFT_RIGHT: 9, RIGHT_LEFT: 10, LEFT_SHOULDER: 11, RIGHT_SHOULDER: 12, LEFT_ELBOW: 13, RIGHT_ELBOW: 14, LEFT_WRIST: 15, RIGHT_WRIST: 16, LEFT_PINKY: 17, RIGHT_PINKY: 18, LEFT_INDEX: 19, RIGHT_INDEX: 20, LEFT_THUMB: 21, RIGHT_THUMB: 22, LEFT_HIP: 23, RIGHT_HIP: 24, LEFT_KNEE: 25, RIGHT_KNEE: 26, LEFT_ANKLE: 27, RIGHT_ANKLE: 28, LEFT_HEEL: 29, RIGHT_HEEL: 30, LEFT_FOOT_INDEX: 31, RIGHT_FOOT_INDEX: 32 });
      J2("POSE_LANDMARKS_LEFT", { LEFT_EYE_INNER: 1, LEFT_EYE: 2, LEFT_EYE_OUTER: 3, LEFT_EAR: 7, LEFT_RIGHT: 9, LEFT_SHOULDER: 11, LEFT_ELBOW: 13, LEFT_WRIST: 15, LEFT_PINKY: 17, LEFT_INDEX: 19, LEFT_THUMB: 21, LEFT_HIP: 23, LEFT_KNEE: 25, LEFT_ANKLE: 27, LEFT_HEEL: 29, LEFT_FOOT_INDEX: 31 });
      J2("POSE_LANDMARKS_RIGHT", { RIGHT_EYE_INNER: 4, RIGHT_EYE: 5, RIGHT_EYE_OUTER: 6, RIGHT_EAR: 8, RIGHT_LEFT: 10, RIGHT_SHOULDER: 12, RIGHT_ELBOW: 14, RIGHT_WRIST: 16, RIGHT_PINKY: 18, RIGHT_INDEX: 20, RIGHT_THUMB: 22, RIGHT_HIP: 24, RIGHT_KNEE: 26, RIGHT_ANKLE: 28, RIGHT_HEEL: 30, RIGHT_FOOT_INDEX: 32 });
      J2("POSE_LANDMARKS_NEUTRAL", { NOSE: 0 });
      J2("VERSION", "0.5.1635988162");
    }).call(exports);
  }
});

// node_modules/@tensorflow-models/pose-detection/dist/pose-detection.esm.js
var import_pose = __toESM(require_pose());
var E = function(t2, e) {
  return (E = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t3, e2) {
    t3.__proto__ = e2;
  } || function(t3, e2) {
    for (var i in e2)
      e2.hasOwnProperty(i) && (t3[i] = e2[i]);
  })(t2, e);
};
function z(t2, e) {
  function i() {
    this.constructor = t2;
  }
  E(t2, e), t2.prototype = null === e ? Object.create(e) : (i.prototype = e.prototype, new i());
}
var V = function() {
  return (V = Object.assign || function(t2) {
    for (var e, i = 1, n = arguments.length; i < n; i++)
      for (var r in e = arguments[i])
        Object.prototype.hasOwnProperty.call(e, r) && (t2[r] = e[r]);
    return t2;
  }).apply(this, arguments);
};
function L(t2, e, i, n) {
  return new (i || (i = Promise))(function(r, o) {
    function a(t3) {
      try {
        l(n.next(t3));
      } catch (t4) {
        o(t4);
      }
    }
    function s(t3) {
      try {
        l(n.throw(t3));
      } catch (t4) {
        o(t4);
      }
    }
    function l(t3) {
      var e2;
      t3.done ? r(t3.value) : (e2 = t3.value, e2 instanceof i ? e2 : new i(function(t4) {
        t4(e2);
      })).then(a, s);
    }
    l((n = n.apply(t2, e || [])).next());
  });
}
function B(t2, e) {
  var i, n, r, o, a = { label: 0, sent: function() {
    if (1 & r[0])
      throw r[1];
    return r[1];
  }, trys: [], ops: [] };
  return o = { next: s(0), throw: s(1), return: s(2) }, "function" == typeof Symbol && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function s(o2) {
    return function(s2) {
      return function(o3) {
        if (i)
          throw new TypeError("Generator is already executing.");
        for (; a; )
          try {
            if (i = 1, n && (r = 2 & o3[0] ? n.return : o3[0] ? n.throw || ((r = n.return) && r.call(n), 0) : n.next) && !(r = r.call(n, o3[1])).done)
              return r;
            switch (n = 0, r && (o3 = [2 & o3[0], r.value]), o3[0]) {
              case 0:
              case 1:
                r = o3;
                break;
              case 4:
                return a.label++, { value: o3[1], done: false };
              case 5:
                a.label++, n = o3[1], o3 = [0];
                continue;
              case 7:
                o3 = a.ops.pop(), a.trys.pop();
                continue;
              default:
                if (!(r = a.trys, (r = r.length > 0 && r[r.length - 1]) || 6 !== o3[0] && 2 !== o3[0])) {
                  a = 0;
                  continue;
                }
                if (3 === o3[0] && (!r || o3[1] > r[0] && o3[1] < r[3])) {
                  a.label = o3[1];
                  break;
                }
                if (6 === o3[0] && a.label < r[1]) {
                  a.label = r[1], r = o3;
                  break;
                }
                if (r && a.label < r[2]) {
                  a.label = r[2], a.ops.push(o3);
                  break;
                }
                r[2] && a.ops.pop(), a.trys.pop();
                continue;
            }
            o3 = e.call(t2, a);
          } catch (t3) {
            o3 = [6, t3], n = 0;
          } finally {
            i = r = 0;
          }
        if (5 & o3[0])
          throw o3[1];
        return { value: o3[0] ? o3[1] : void 0, done: true };
      }([o2, s2]);
    };
  }
}
function N() {
  for (var t2 = 0, e = 0, i = arguments.length; e < i; e++)
    t2 += arguments[e].length;
  var n = Array(t2), r = 0;
  for (e = 0; e < i; e++)
    for (var o = arguments[e], a = 0, s = o.length; a < s; a++, r++)
      n[r] = o[a];
  return n;
}
var D = ["nose", "left_eye", "right_eye", "left_ear", "right_ear", "left_shoulder", "right_shoulder", "left_elbow", "right_elbow", "left_wrist", "right_wrist", "left_hip", "right_hip", "left_knee", "right_knee", "left_ankle", "right_ankle"];
var K = ["nose", "left_eye_inner", "left_eye", "left_eye_outer", "right_eye_inner", "right_eye", "right_eye_outer", "left_ear", "right_ear", "mouth_left", "mouth_right", "left_shoulder", "right_shoulder", "left_elbow", "right_elbow", "left_wrist", "right_wrist", "left_pinky", "right_pinky", "left_index", "right_index", "left_thumb", "right_thumb", "left_hip", "right_hip", "left_knee", "right_knee", "left_ankle", "right_ankle", "left_heel", "right_heel", "left_foot_index", "right_foot_index"];
var j = { left: [1, 2, 3, 7, 9, 11, 13, 15, 17, 19, 21, 23, 25, 27, 29, 31], right: [4, 5, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24, 26, 28, 30, 32], middle: [0] };
var H = { left: [1, 3, 5, 7, 9, 11, 13, 15], right: [2, 4, 6, 8, 10, 12, 14, 16], middle: [0] };
var q = [[0, 1], [0, 2], [1, 3], [2, 4], [5, 6], [5, 7], [5, 11], [6, 8], [6, 12], [7, 9], [8, 10], [11, 12], [11, 13], [12, 14], [13, 15], [14, 16]];
var U = [[0, 1], [0, 4], [1, 2], [2, 3], [3, 7], [4, 5], [5, 6], [6, 8], [9, 10], [11, 12], [11, 13], [11, 23], [12, 14], [14, 16], [12, 24], [13, 15], [15, 17], [16, 18], [16, 20], [15, 17], [15, 19], [15, 21], [16, 22], [17, 19], [18, 20], [23, 25], [23, 24], [24, 26], [25, 27], [26, 28], [27, 29], [28, 30], [27, 31], [28, 32], [29, 31], [30, 32]];
function X(t2) {
  return t2 instanceof SVGAnimatedLength ? t2.baseVal.value : t2;
}
function W(t2) {
  return L(this, void 0, void 0, function() {
    var n, r;
    return B(this, function(o) {
      switch (o.label) {
        case 0:
          return n = document.createElement("canvas"), t2 instanceof Tensor ? [4, browser_exports.toPixels(t2, n)] : [3, 2];
        case 1:
          return o.sent(), [3, 3];
        case 2:
          n.width = X(t2.width), n.height = X(t2.height), r = n.getContext("2d"), t2 instanceof ImageData ? r.putImageData(t2, 0, 0) : r.drawImage(t2, 0, 0), o.label = 3;
        case 3:
          return [2, n];
      }
    });
  });
}
function Y(t2) {
  return L(this, void 0, void 0, function() {
    var n, r, o, a, s, l;
    return B(this, function(u) {
      switch (u.label) {
        case 0:
          return t2 instanceof Tensor ? (n = t2.shape.slice(0, 2), r = n[0], o = n[1], a = ImageData.bind, [4, browser_exports.toPixels(t2)]) : [3, 2];
        case 1:
          return [2, new (a.apply(ImageData, [void 0, u.sent(), o, r]))()];
        case 2:
          return s = document.createElement("canvas"), l = s.getContext("2d"), s.width = X(t2.width), s.height = X(t2.height), l.drawImage(t2, 0, 0), [2, l.getImageData(0, 0, s.width, s.height)];
      }
    });
  });
}
function G(t2) {
  return L(this, void 0, void 0, function() {
    var e, n;
    return B(this, function(r) {
      switch (r.label) {
        case 0:
          return t2 instanceof SVGImageElement || t2 instanceof OffscreenCanvas ? [4, W(t2)] : [3, 2];
        case 1:
          return n = r.sent(), [3, 3];
        case 2:
          n = t2, r.label = 3;
        case 3:
          return e = n, [2, browser_exports.fromPixels(e, 4)];
      }
    });
  });
}
function Q(t2) {
  if (t2 < 0 || t2 >= 256)
    throw new Error("Mask value must be in range [0, 255] but got " + t2);
  if (!Number.isInteger(t2))
    throw new Error("Mask value must be an integer but got " + t2);
}
var Z = { runtime: "mediapipe", enableSmoothing: true, enableSegmentation: false, smoothSegmentation: true, modelType: "full" };
var $ = function() {
  function t2(t3) {
    this.mask = t3;
  }
  return t2.prototype.toCanvasImageSource = function() {
    return L(this, void 0, void 0, function() {
      return B(this, function(t3) {
        return [2, this.mask];
      });
    });
  }, t2.prototype.toImageData = function() {
    return L(this, void 0, void 0, function() {
      return B(this, function(t3) {
        return [2, Y(this.mask)];
      });
    });
  }, t2.prototype.toTensor = function() {
    return L(this, void 0, void 0, function() {
      return B(this, function(t3) {
        return [2, G(this.mask)];
      });
    });
  }, t2.prototype.getUnderlyingType = function() {
    return "canvasimagesource";
  }, t2;
}();
function J(t2) {
  return Q(t2), "person";
}
var tt = function() {
  function n(e) {
    var i, n2 = this;
    switch (this.width = 0, this.height = 0, this.selfieMode = false, this.poseSolution = new import_pose.Pose({ locateFile: function(t2, i2) {
      return e.solutionPath ? e.solutionPath.replace(/\/+$/, "") + "/" + t2 : i2 + "/" + t2;
    } }), e.modelType) {
      case "lite":
        i = 0;
        break;
      case "heavy":
        i = 2;
        break;
      case "full":
      default:
        i = 1;
    }
    this.poseSolution.setOptions({ modelComplexity: i, smoothLandmarks: e.enableSmoothing, enableSegmentation: e.enableSegmentation, smoothSegmentation: e.smoothSegmentation, selfieMode: this.selfieMode }), this.poseSolution.onResults(function(t2) {
      if (n2.height = t2.image.height, n2.width = t2.image.width, null == t2.poseLandmarks)
        n2.poses = [];
      else {
        var e2 = n2.translateOutput(t2.poseLandmarks, t2.poseWorldLandmarks);
        t2.segmentationMask && (e2.segmentation = { maskValueToLabel: J, mask: new $(t2.segmentationMask) }), n2.poses = [e2];
      }
    });
  }
  return n.prototype.translateOutput = function(t2, e) {
    var i = this, n2 = { keypoints: t2.map(function(t3, e2) {
      return { x: t3.x * i.width, y: t3.y * i.height, z: t3.z, score: t3.visibility, name: K[e2] };
    }) };
    return null != e && (n2.keypoints3D = e.map(function(t3, e2) {
      return { x: t3.x, y: t3.y, z: t3.z, score: t3.visibility, name: K[e2] };
    })), n2;
  }, n.prototype.estimatePoses = function(t2, n2, r) {
    return L(this, void 0, void 0, function() {
      var o, a;
      return B(this, function(s) {
        switch (s.label) {
          case 0:
            return n2 && n2.flipHorizontal && n2.flipHorizontal !== this.selfieMode && (this.selfieMode = n2.flipHorizontal, this.poseSolution.setOptions({ selfieMode: this.selfieMode })), t2 instanceof Tensor ? (a = ImageData.bind, [4, browser_exports.toPixels(t2)]) : [3, 2];
          case 1:
            return o = new (a.apply(ImageData, [void 0, s.sent(), t2.shape[1], t2.shape[0]]))(), [3, 3];
          case 2:
            o = t2, s.label = 3;
          case 3:
            return t2 = o, [4, this.poseSolution.send({ image: t2 }, r)];
          case 4:
            return s.sent(), [2, this.poses];
        }
      });
    });
  }, n.prototype.dispose = function() {
    this.poseSolution.close();
  }, n.prototype.reset = function() {
    this.poseSolution.reset();
  }, n.prototype.initialize = function() {
    return this.poseSolution.initialize();
  }, n;
}();
function et(t2) {
  return L(this, void 0, void 0, function() {
    var e, i;
    return B(this, function(n) {
      switch (n.label) {
        case 0:
          return e = function(t3) {
            if (null == t3)
              return V({}, Z);
            var e2 = V({}, t3);
            return e2.runtime = "mediapipe", null == e2.enableSegmentation && (e2.enableSegmentation = Z.enableSegmentation), null == e2.enableSmoothing && (e2.enableSmoothing = Z.enableSmoothing), null == e2.smoothSegmentation && (e2.smoothSegmentation = Z.smoothSegmentation), null == e2.modelType && (e2.modelType = Z.modelType), e2;
          }(t2), [4, (i = new tt(e)).initialize()];
        case 1:
          return n.sent(), [2, i];
      }
    });
  });
}
function it(t2) {
  return t2 instanceof Tensor ? { height: t2.shape[0], width: t2.shape[1] } : { height: t2.height, width: t2.width };
}
function nt(t2) {
  return t2 - 2 * Math.PI * Math.floor((t2 + Math.PI) / (2 * Math.PI));
}
function rt(t2) {
  return t2 instanceof Tensor ? t2 : browser_exports.fromPixels(t2);
}
function ot(t2, e, i) {
  return at(i, "inputResolution"), [1 / i.width * t2[0][0] * e.width, 1 / i.height * t2[0][1] * e.width, t2[0][3] * e.width, 1 / i.width * t2[1][0] * e.height, 1 / i.height * t2[1][1] * e.height, t2[1][3] * e.height, 0, 0];
}
function at(t2, e) {
  util_exports.assert(0 !== t2.width, function() {
    return e + " width cannot be 0.";
  }), util_exports.assert(0 !== t2.height, function() {
    return e + " height cannot be 0.";
  });
}
function st(t2, e, i) {
  var n = i.rotationVectorStartKeypointIndex, r = i.rotationVectorEndKeypointIndex, o = t2.locationData, a = o.relativeKeypoints[n].x * e.width, s = o.relativeKeypoints[n].y * e.height, l = o.relativeKeypoints[r].x * e.width, u = o.relativeKeypoints[r].y * e.height, h = 2 * Math.sqrt((l - a) * (l - a) + (u - s) * (u - s)), c = function(t3, e2, i2) {
    var n2, r2 = t3.locationData, o2 = i2.rotationVectorStartKeypointIndex, a2 = i2.rotationVectorEndKeypointIndex;
    n2 = i2.rotationVectorTargetAngle ? i2.rotationVectorTargetAngle : Math.PI * i2.rotationVectorTargetAngleDegree / 180;
    var s2 = r2.relativeKeypoints[o2].x * e2.width, l2 = r2.relativeKeypoints[o2].y * e2.height, u2 = r2.relativeKeypoints[a2].x * e2.width, h2 = r2.relativeKeypoints[a2].y * e2.height;
    return nt(n2 - Math.atan2(-(h2 - l2), u2 - s2));
  }(t2, e, i);
  return { xCenter: a / e.width, yCenter: s / e.height, width: h / e.width, height: h / e.height, rotation: c };
}
function lt(t2) {
  if (16 !== t2.length)
    throw new Error("Array length must be 16 but got " + t2.length);
  return [[t2[0], t2[1], t2[2], t2[3]], [t2[4], t2[5], t2[6], t2[7]], [t2[8], t2[9], t2[10], t2[11]], [t2[12], t2[13], t2[14], t2[15]]];
}
function ut(t2, e, i, n, r, o, a) {
  return t2[e][r] * (t2[i][o] * t2[n][a] - t2[i][a] * t2[n][o]);
}
function ht(t2, e, i) {
  var n = (e + 1) % 4, r = (e + 2) % 4, o = (e + 3) % 4, a = (i + 1) % 4, s = (i + 2) % 4, l = (i + 3) % 4;
  return ut(t2, n, r, o, a, s, l) + ut(t2, r, o, n, a, s, l) + ut(t2, o, n, r, a, s, l);
}
function ct(t2, e, i) {
  void 0 === i && (i = { ignoreRotation: false });
  for (var n = [], r = 0, o = t2; r < o.length; r++) {
    var a = o[r], s = a.x - 0.5, l = a.y - 0.5, u = i.ignoreRotation ? 0 : e.rotation, h = Math.cos(u) * s - Math.sin(u) * l, c = Math.sin(u) * s + Math.cos(u) * l;
    h = h * e.width + e.xCenter, c = c * e.height + e.yCenter;
    var p = a.z * e.width, f = V({}, a);
    f.x = h, f.y = c, f.z = p, n.push(f);
  }
  return n;
}
function pt(t2, e) {
  var i = function(t3, e2, i2, n) {
    var r = e2 - t3, o = n - i2;
    if (0 === r)
      throw new Error("Original min and max are both " + t3 + ", range cannot be 0.");
    var a = o / r;
    return { scale: a, offset: i2 - t3 * a };
  }(0, 255, e[0], e[1]);
  return tidy(function() {
    return add(mul(t2, i.scale), i.offset);
  });
}
function ft(t2, e, i) {
  var n, o, a, c, p, f, d, m, g, y, v, x, w, k, b = e.outputTensorSize, M = e.keepAspectRatio, S = e.borderMode, T = e.outputTensorFloatRange, P = it(t2), F = function(t3, e2) {
    return e2 ? { xCenter: e2.xCenter * t3.width, yCenter: e2.yCenter * t3.height, width: e2.width * t3.width, height: e2.height * t3.height, rotation: e2.rotation } : { xCenter: 0.5 * t3.width, yCenter: 0.5 * t3.height, width: t3.width, height: t3.height, rotation: 0 };
  }(P, i), _ = function(t3, e2, i2) {
    if (void 0 === i2 && (i2 = false), !i2)
      return { top: 0, left: 0, right: 0, bottom: 0 };
    var n2 = e2.height, r = e2.width;
    at(e2, "targetSize"), at(t3, "roi");
    var o2, a2, s = n2 / r, l = t3.height / t3.width, u = 0, h = 0;
    return s > l ? (o2 = t3.width, a2 = t3.width * s, h = (1 - l / s) / 2) : (o2 = t3.height / s, a2 = t3.height, u = (1 - s / l) / 2), t3.width = o2, t3.height = a2, { top: h, left: u, right: u, bottom: h };
  }(F, b, M), O = (n = F, o = P.width, a = P.height, c = false, p = n.width, f = n.height, d = c ? -1 : 1, m = Math.cos(n.rotation), g = Math.sin(n.rotation), y = n.xCenter, v = n.yCenter, x = 1 / o, w = 1 / a, (k = new Array(16))[0] = p * m * d * x, k[1] = -f * g * x, k[2] = 0, k[3] = (-0.5 * p * m * d + 0.5 * f * g + y) * x, k[4] = p * g * d * w, k[5] = f * m * w, k[6] = 0, k[7] = (-0.5 * f * m - 0.5 * p * g * d + v) * w, k[8] = 0, k[9] = 0, k[10] = p * x, k[11] = 0, k[12] = 0, k[13] = 0, k[14] = 0, k[15] = 1, lt(k));
  return { imageTensor: tidy(function() {
    var e2 = rt(t2), i2 = tensor2d(ot(O, P, b), [1, 8]), n2 = "zero" === S ? "constant" : "nearest", r = image.transform(expandDims(cast(e2, "float32")), i2, "bilinear", n2, 0, [b.height, b.width]);
    return null != T ? pt(r, T) : r;
  }), padding: _, transformationMatrix: O };
}
function dt(t2, e, i, n) {
  return 1 === n ? 0.5 * (t2 + e) : t2 + (e - t2) * i / (n - 1);
}
function mt(t2) {
  return tidy(function() {
    var e = function(t3) {
      return tidy(function() {
        return [slice(t3, [0, 0, 0], [1, -1, 1]), slice(t3, [0, 0, 1], [1, -1, -1])];
      });
    }(t2), i = e[0], n = e[1];
    return { boxes: squeeze(n), logits: squeeze(i) };
  });
}
function gt(t2) {
  return null != t2 && null != t2.currentTime;
}
function yt(t2) {
  for (var e = { locationData: { relativeKeypoints: [] } }, i = Number.MAX_SAFE_INTEGER, n = Number.MIN_SAFE_INTEGER, r = Number.MAX_SAFE_INTEGER, o = Number.MIN_SAFE_INTEGER, a = 0; a < t2.length; ++a) {
    var s = t2[a];
    i = Math.min(i, s.x), n = Math.max(n, s.x), r = Math.min(r, s.y), o = Math.max(o, s.y), e.locationData.relativeKeypoints.push({ x: s.x, y: s.y });
  }
  return e.locationData.relativeBoundingBox = { xMin: i, yMin: r, xMax: n, yMax: o, width: n - i, height: o - r }, e;
}
function vt(t2, e, i, n) {
  return L(this, void 0, void 0, function() {
    var n2, r, o, a, u;
    return B(this, function(h) {
      switch (h.label) {
        case 0:
          return t2.sort(function(t3, e2) {
            return Math.max.apply(Math, e2.score) - Math.max.apply(Math, t3.score);
          }), n2 = tensor2d(t2.map(function(t3) {
            return [t3.locationData.relativeBoundingBox.yMin, t3.locationData.relativeBoundingBox.xMin, t3.locationData.relativeBoundingBox.yMax, t3.locationData.relativeBoundingBox.xMax];
          })), r = tensor1d(t2.map(function(t3) {
            return t3.score[0];
          })), [4, image.nonMaxSuppressionAsync(n2, r, e, i)];
        case 1:
          return [4, (o = h.sent()).array()];
        case 2:
          return a = h.sent(), u = t2.filter(function(t3, e2) {
            return a.indexOf(e2) > -1;
          }), dispose([n2, r, o]), [2, u];
      }
    });
  });
}
function xt(t2, e) {
  return t2.map(function(t3) {
    var i = V(V({}, t3), { x: t3.x * e.width, y: t3.y * e.height });
    return null != t3.z && (i.z = t3.z * e.width), i;
  });
}
function wt(t2, e, i) {
  return L(this, void 0, void 0, function() {
    var n, r, o, a, s, l, u, h, c, f, d, m, g, y, v, x, w, k, b, M, S, T, P, F;
    return B(this, function(_) {
      switch (_.label) {
        case 0:
          if (n = squeeze(e, [0]), r = n.shape, o = r[0], a = r[1], s = r[2], t2.length !== s)
            throw new Error("Expected heatmap to have same number of channels as the number of landmarks. But got landmarks length: " + t2.length + ", heatmap length: " + s);
          return l = [], [4, n.buffer()];
        case 1:
          for (u = _.sent(), h = 0; h < t2.length; h++)
            if (c = t2[h], f = V({}, c), l.push(f), d = Math.trunc(f.x * a), m = Math.trunc(f.y * o), !(d < 0 || d >= a || m < 0 || d >= o)) {
              for (g = Math.trunc((i.kernelSize - 1) / 2), y = Math.max(0, d - g), v = Math.min(a, d + g + 1), x = Math.max(0, m - g), w = Math.min(o, m + g + 1), k = 0, b = 0, M = 0, S = 0, T = x; T < w; ++T)
                for (P = y; P < v; ++P)
                  F = u.get(T, P, h), k += F, S = Math.max(S, F), b += P * F, M += T * F;
              S >= i.minConfidenceToRefine && k > 0 && (f.x = b / a / k, f.y = M / o / k);
            }
          return n.dispose(), [2, l];
      }
    });
  });
}
function kt(t2, e) {
  var i = e.left, n = e.top, r = e.left + e.right, o = e.top + e.bottom;
  return t2.map(function(t3) {
    return V(V({}, t3), { x: (t3.x - i) / (1 - r), y: (t3.y - n) / (1 - o), z: t3.z / (1 - r) });
  });
}
function bt(t2, e, i) {
  return "webgl" === getBackend() ? function(t3, e2, i2) {
    var n = i2.combineWithPreviousRatio.toFixed(2), o = { variableNames: ["prevMask", "newMask"], outputShape: t3.shape, userCode: "\n  void main() {\n      ivec2 coords = getOutputCoords();\n      int height = coords[0];\n      int width = coords[1];\n\n      float prevMaskValue = getPrevMask(height, width);\n      float newMaskValue = getNewMask(height, width);\n\n      /*\n      * Assume p := newMaskValue\n      * H(p) := 1 + (p * log(p) + (1-p) * log(1-p)) / log(2)\n      * uncertainty alpha(p) =\n      *   Clamp(1 - (1 - H(p)) * (1 - H(p)), 0, 1) [squaring the\n      * uncertainty]\n      *\n      * The following polynomial approximates uncertainty alpha as a\n      * function of (p + 0.5):\n      */\n      const float c1 = 5.68842;\n      const float c2 = -0.748699;\n      const float c3 = -57.8051;\n      const float c4 = 291.309;\n      const float c5 = -624.717;\n      float t = newMaskValue - 0.5;\n      float x = t * t;\n\n      float uncertainty =\n        1.0 - min(1.0, x * (c1 + x * (c2 + x * (c3 + x * (c4 + x * c5)))));\n\n      float outputValue = newMaskValue + (prevMaskValue - newMaskValue) *\n                             (uncertainty * " + n + ");\n\n      setOutput(outputValue);\n    }\n" }, a = backend();
    return tidy(function() {
      var i3 = a.compileAndRun(o, [t3, e2]);
      return engine().makeTensorFromDataId(i3.dataId, i3.shape, i3.dtype);
    });
  }(t2, e, i) : tidy(function() {
    var n = sub(e, 0.5), r = square(n), s = sub(1, minimum(1, mul(r, add(5.68842, mul(r, add(-0.748699, mul(r, add(-57.8051, mul(r, add(291.309, mul(r, -624.717)))))))))));
    return add(e, mul(sub(t2, e), mul(s, i.combineWithPreviousRatio)));
  });
}
function Mt(t2, e, i) {
  return L(this, void 0, void 0, function() {
    var n, s, l, u, h;
    return B(this, function(d) {
      switch (d.label) {
        case 0:
          return n = t2[0], s = t2[1], l = function(t3, e2, i2) {
            return tidy(function() {
              var n2, r, s2, l2;
              i2.reverseOutputOrder ? (r = squeeze(slice(t3, [0, i2.boxCoordOffset + 0], [-1, 1])), n2 = squeeze(slice(t3, [0, i2.boxCoordOffset + 1], [-1, 1])), l2 = squeeze(slice(t3, [0, i2.boxCoordOffset + 2], [-1, 1])), s2 = squeeze(slice(t3, [0, i2.boxCoordOffset + 3], [-1, 1]))) : (n2 = squeeze(slice(t3, [0, i2.boxCoordOffset + 0], [-1, 1])), r = squeeze(slice(t3, [0, i2.boxCoordOffset + 1], [-1, 1])), s2 = squeeze(slice(t3, [0, i2.boxCoordOffset + 2], [-1, 1])), l2 = squeeze(slice(t3, [0, i2.boxCoordOffset + 3], [-1, 1]))), r = add(mul(div(r, i2.xScale), e2.w), e2.x), n2 = add(mul(div(n2, i2.yScale), e2.h), e2.y), i2.applyExponentialOnBoxSize ? (s2 = mul(exp(div(s2, i2.hScale)), e2.h), l2 = mul(exp(div(l2, i2.wScale)), e2.w)) : (s2 = mul(div(s2, i2.hScale), e2.h), l2 = mul(div(l2, i2.wScale), e2.h));
              var u2 = sub(n2, div(s2, 2)), h2 = sub(r, div(l2, 2)), f = add(n2, div(s2, 2)), d2 = add(r, div(l2, 2)), m = concat([reshape(u2, [i2.numBoxes, 1]), reshape(h2, [i2.numBoxes, 1]), reshape(f, [i2.numBoxes, 1]), reshape(d2, [i2.numBoxes, 1])], 1);
              if (i2.numKeypoints)
                for (var g = 0; g < i2.numKeypoints; ++g) {
                  var v = i2.keypointCoordOffset + g * i2.numValuesPerKeypoint, x = void 0, w = void 0;
                  i2.reverseOutputOrder ? (x = squeeze(slice(t3, [0, v], [-1, 1])), w = squeeze(slice(t3, [0, v + 1], [-1, 1]))) : (w = squeeze(slice(t3, [0, v], [-1, 1])), x = squeeze(slice(t3, [0, v + 1], [-1, 1])));
                  var T = add(mul(div(x, i2.xScale), e2.w), e2.x), P = add(mul(div(w, i2.yScale), e2.h), e2.y);
                  m = concat([m, reshape(T, [i2.numBoxes, 1]), reshape(P, [i2.numBoxes, 1])], 1);
                }
              return m;
            });
          }(s, e, i), u = tidy(function() {
            var t3 = n;
            return i.sigmoidScore ? (null != i.scoreClippingThresh && (t3 = clipByValue(n, -i.scoreClippingThresh, i.scoreClippingThresh)), t3 = sigmoid(t3)) : t3;
          }), [4, St(l, u, i)];
        case 1:
          return h = d.sent(), dispose([l, u]), [2, h];
      }
    });
  });
}
function St(t2, e, i) {
  return L(this, void 0, void 0, function() {
    var n, r, o, a, s, l, u, h, c, p, f, d;
    return B(this, function(m) {
      switch (m.label) {
        case 0:
          return n = [], [4, t2.data()];
        case 1:
          return r = m.sent(), [4, e.data()];
        case 2:
          for (o = m.sent(), a = 0; a < i.numBoxes; ++a)
            if (!(null != i.minScoreThresh && o[a] < i.minScoreThresh || (s = a * i.numCoords, l = Tt(r[s + 0], r[s + 1], r[s + 2], r[s + 3], o[a], i.flipVertically, a), (u = l.locationData.relativeBoundingBox).width < 0 || u.height < 0))) {
              if (i.numKeypoints > 0)
                for ((h = l.locationData).relativeKeypoints = [], c = i.numKeypoints * i.numValuesPerKeypoint, p = 0; p < c; p += i.numValuesPerKeypoint)
                  f = s + i.keypointCoordOffset + p, d = { x: r[f + 0], y: i.flipVertically ? 1 - r[f + 1] : r[f + 1] }, h.relativeKeypoints.push(d);
              n.push(l);
            }
          return [2, n];
      }
    });
  });
}
function Tt(t2, e, i, n, r, o, a) {
  return { score: [r], ind: a, locationData: { relativeBoundingBox: { xMin: e, yMin: o ? 1 - i : t2, xMax: n, yMax: o ? 1 - t2 : i, width: n - e, height: i - t2 } } };
}
function Pt(t2, e) {
  return "none" === t2 ? e : function(t3) {
    return 1 / (1 + Math.exp(-t3));
  }(e);
}
function Ft(t2, e, i, n) {
  return L(this, void 0, void 0, function() {
    var r, o, a, s, l, u, h, c;
    return B(this, function(p) {
      switch (p.label) {
        case 0:
          return i = i || e.flipHorizontally || false, n = n || e.flipVertically || false, r = t2.size, o = r / e.numLandmarks, [4, t2.data()];
        case 1:
          for (a = p.sent(), s = [], l = 0; l < e.numLandmarks; ++l)
            u = l * o, (c = { x: 0, y: 0 }).x = i ? e.inputImageWidth - a[u] : a[u], o > 1 && (c.y = n ? e.inputImageHeight - a[u + 1] : a[u + 1]), o > 2 && (c.z = a[u + 2]), o > 3 && (c.score = Pt(e.visibilityActivation, a[u + 3])), s.push(c);
          for (h = 0; h < s.length; ++h)
            (c = s[h]).x = c.x / e.inputImageWidth, c.y = c.y / e.inputImageHeight, c.z = c.z / e.inputImageWidth / (e.normalizeZ || 1);
          return [2, s];
      }
    });
  });
}
function _t(t2, e, i) {
  var n = t2.width, r = t2.height, o = t2.rotation;
  if (null == i.rotation && null == i.rotationDegree || (o = function(t3, e2) {
    null != e2.rotation ? t3 += e2.rotation : null != e2.rotationDegree && (t3 += Math.PI * e2.rotationDegree / 180);
    return nt(t3);
  }(o, i)), 0 === o)
    t2.xCenter = t2.xCenter + n * i.shiftX, t2.yCenter = t2.yCenter + r * i.shiftY;
  else {
    var a = (e.width * n * i.shiftX * Math.cos(o) - e.height * r * i.shiftY * Math.sin(o)) / e.width, s = (e.width * n * i.shiftX * Math.sin(o) + e.height * r * i.shiftY * Math.cos(o)) / e.height;
    t2.xCenter = t2.xCenter + a, t2.yCenter = t2.yCenter + s;
  }
  if (i.squareLong) {
    var l = Math.max(n * e.width, r * e.height);
    n = l / e.width, r = l / e.height;
  } else if (i.squareShort) {
    var u = Math.min(n * e.width, r * e.height);
    n = u / e.width, r = u / e.height;
  }
  return t2.width = n * i.scaleX, t2.height = r * i.scaleY, t2;
}
function Ot(t2, e) {
  return t2.map(function(t3) {
    var i = V(V({}, t3), { x: t3.x / e.width, y: t3.y / e.height });
    return null != t3.z && (t3.z = t3.z / e.width), i;
  });
}
var At = function() {
  function t2(t3) {
    this.alpha = t3, this.initialized = false;
  }
  return t2.prototype.apply = function(t3, e) {
    var i;
    return this.initialized ? i = null == e ? this.storedValue + this.alpha * (t3 - this.storedValue) : this.storedValue + this.alpha * e * Math.asinh((t3 - this.storedValue) / e) : (i = t3, this.initialized = true), this.rawValue = t3, this.storedValue = i, i;
  }, t2.prototype.applyWithAlpha = function(t3, e, i) {
    return this.alpha = e, this.apply(t3, i);
  }, t2.prototype.hasLastRawValue = function() {
    return this.initialized;
  }, t2.prototype.lastRawValue = function() {
    return this.rawValue;
  }, t2.prototype.reset = function() {
    this.initialized = false;
  }, t2;
}();
var It = function() {
  function t2(t3) {
    this.frequency = t3.frequency, this.minCutOff = t3.minCutOff, this.beta = t3.beta, this.thresholdCutOff = t3.thresholdCutOff, this.thresholdBeta = t3.thresholdBeta, this.derivateCutOff = t3.derivateCutOff, this.x = new At(this.getAlpha(this.minCutOff)), this.dx = new At(this.getAlpha(this.derivateCutOff)), this.lastTimestamp = 0;
  }
  return t2.prototype.apply = function(t3, e, i) {
    if (null == t3)
      return t3;
    var n = Math.trunc(e);
    if (this.lastTimestamp >= n)
      return t3;
    0 !== this.lastTimestamp && 0 !== n && (this.frequency = 1 / (1e-6 * (n - this.lastTimestamp))), this.lastTimestamp = n;
    var r = this.x.hasLastRawValue() ? (t3 - this.x.lastRawValue()) * i * this.frequency : 0, o = this.dx.applyWithAlpha(r, this.getAlpha(this.derivateCutOff)), a = this.minCutOff + this.beta * Math.abs(o), s = null != this.thresholdCutOff ? this.thresholdCutOff + this.thresholdBeta * Math.abs(o) : null;
    return this.x.applyWithAlpha(t3, this.getAlpha(a), s);
  }, t2.prototype.getAlpha = function(t3) {
    return 1 / (1 + this.frequency / (2 * Math.PI * t3));
  }, t2;
}();
var Ct = function() {
  function t2(t3) {
    this.config = t3;
  }
  return t2.prototype.apply = function(t3, e, i) {
    var n = this;
    if (null == t3)
      return this.reset(), null;
    this.initializeFiltersIfEmpty(t3);
    var r = 1;
    if (!this.config.disableValueScaling) {
      if (i < this.config.minAllowedObjectScale)
        return N(t3);
      r = 1 / i;
    }
    return t3.map(function(t4, i2) {
      var o = V(V({}, t4), { x: n.xFilters[i2].apply(t4.x, e, r), y: n.yFilters[i2].apply(t4.y, e, r) });
      return null != t4.z && (o.z = n.zFilters[i2].apply(t4.z, e, r)), o;
    });
  }, t2.prototype.reset = function() {
    this.xFilters = null, this.yFilters = null, this.zFilters = null;
  }, t2.prototype.initializeFiltersIfEmpty = function(t3) {
    var e = this;
    null != this.xFilters && this.xFilters.length === t3.length || (this.xFilters = t3.map(function(t4) {
      return new It(e.config);
    }), this.yFilters = t3.map(function(t4) {
      return new It(e.config);
    }), this.zFilters = t3.map(function(t4) {
      return new It(e.config);
    }));
  }, t2;
}();
var Rt = function() {
  function t2(t3) {
    this.config = t3, this.window = [], this.lowPassFilter = new At(1), this.lastValue = 0, this.lastValueScale = 1, this.lastTimestamp = -1;
  }
  return t2.prototype.apply = function(t3, e, i) {
    if (null == t3)
      return t3;
    var n, r = Math.trunc(e);
    if (this.lastTimestamp >= r)
      return t3;
    if (-1 === this.lastTimestamp)
      n = 1;
    else {
      for (var o = t3 * i - this.lastValue * this.lastValueScale, a = r - this.lastTimestamp, s = o, l = a, u = (1 + this.window.length) * (1e6 / 30), h = 0, c = this.window; h < c.length; h++) {
        var p = c[h];
        if (l + p.duration > u)
          break;
        s += p.distance, l += p.duration;
      }
      var f = s / (1e-6 * l);
      n = 1 - 1 / (1 + this.config.velocityScale * Math.abs(f)), this.window.unshift({ distance: o, duration: a }), this.window.length > this.config.windowSize && this.window.pop();
    }
    return this.lastValue = t3, this.lastValueScale = i, this.lastTimestamp = r, this.lowPassFilter.applyWithAlpha(t3, n);
  }, t2;
}();
var Et = function() {
  function t2(t3) {
    this.config = t3;
  }
  return t2.prototype.apply = function(t3, e, i) {
    var n = this;
    if (null == t3)
      return this.reset(), null;
    var r = 1;
    if (!this.config.disableValueScaling) {
      if (i < this.config.minAllowedObjectScale)
        return N(t3);
      r = 1 / i;
    }
    return this.initializeFiltersIfEmpty(t3), t3.map(function(t4, i2) {
      var o = V(V({}, t4), { x: n.xFilters[i2].apply(t4.x, e, r), y: n.yFilters[i2].apply(t4.y, e, r) });
      return null != t4.z && (o.z = n.zFilters[i2].apply(t4.z, e, r)), o;
    });
  }, t2.prototype.reset = function() {
    this.xFilters = null, this.yFilters = null, this.zFilters = null;
  }, t2.prototype.initializeFiltersIfEmpty = function(t3) {
    var e = this;
    null != this.xFilters && this.xFilters.length === t3.length || (this.xFilters = t3.map(function(t4) {
      return new Rt(e.config);
    }), this.yFilters = t3.map(function(t4) {
      return new Rt(e.config);
    }), this.zFilters = t3.map(function(t4) {
      return new Rt(e.config);
    }));
  }, t2;
}();
var zt = function() {
  function t2(t3) {
    if (null != t3.velocityFilter)
      this.keypointsFilter = new Et(t3.velocityFilter);
    else {
      if (null == t3.oneEuroFilter)
        throw new Error("Either configure velocityFilter or oneEuroFilter, but got " + t3 + ".");
      this.keypointsFilter = new Ct(t3.oneEuroFilter);
    }
  }
  return t2.prototype.apply = function(t3, e, i, n, r) {
    if (void 0 === n && (n = false), null == t3)
      return this.keypointsFilter.reset(), null;
    var o = null != r ? function(t4, e2) {
      return (t4.width * e2.width + t4.height * e2.height) / 2;
    }(r, i) : 1, a = n ? xt(t3, i) : t3, s = this.keypointsFilter.apply(a, e, o);
    return n ? Ot(s, i) : s;
  }, t2;
}();
var Vt = function() {
  function t2(t3) {
    this.alpha = t3.alpha;
  }
  return t2.prototype.apply = function(t3) {
    var e = this;
    if (null == t3)
      return this.visibilityFilters = null, null;
    null != this.visibilityFilters && this.visibilityFilters.length === t3.length || (this.visibilityFilters = t3.map(function(t4) {
      return new At(e.alpha);
    }));
    for (var i = [], n = 0; n < t3.length; ++n) {
      var r = t3[n], o = V({}, r);
      o.score = this.visibilityFilters[n].apply(r.score), i.push(o);
    }
    return i;
  }, t2;
}();
var Lt = { reduceBoxesInLowestlayer: false, interpolatedScaleAspectRatio: 1, featureMapHeight: [], featureMapWidth: [], numLayers: 5, minScale: 0.1484375, maxScale: 0.75, inputSizeHeight: 224, inputSizeWidth: 224, anchorOffsetX: 0.5, anchorOffsetY: 0.5, strides: [8, 16, 32, 32, 32], aspectRatios: [1], fixedAnchorSize: true };
var Bt = { runtime: "tfjs", modelType: "full", enableSmoothing: true, enableSegmentation: false, smoothSegmentation: true, detectorModelUrl: "https://tfhub.dev/mediapipe/tfjs-model/blazepose_3d/detector/1", landmarkModelUrl: "https://tfhub.dev/mediapipe/tfjs-model/blazepose_3d/landmark/full/2" };
var Nt = { maxPoses: 1, flipHorizontal: false };
var Dt = { applyExponentialOnBoxSize: false, flipVertically: false, ignoreClasses: [], numClasses: 1, numBoxes: 2254, numCoords: 12, boxCoordOffset: 0, keypointCoordOffset: 4, numKeypoints: 4, numValuesPerKeypoint: 2, sigmoidScore: true, scoreClippingThresh: 100, reverseOutputOrder: true, xScale: 224, yScale: 224, hScale: 224, wScale: 224, minScoreThresh: 0.5 };
var Kt = 0.3;
var jt = { shiftX: 0, shiftY: 0, scaleX: 1.25, scaleY: 1.25, squareLong: true };
var Ht = { outputTensorSize: { width: 224, height: 224 }, keepAspectRatio: true, outputTensorFloatRange: [-1, 1], borderMode: "zero" };
var qt = { outputTensorSize: { width: 256, height: 256 }, keepAspectRatio: true, outputTensorFloatRange: [0, 1], borderMode: "zero" };
var Ut = { numLandmarks: 39, inputImageWidth: 256, inputImageHeight: 256, visibilityActivation: "sigmoid", flipHorizontally: false, flipVertically: false };
var Xt = { numLandmarks: 39, inputImageWidth: 1, inputImageHeight: 1, visibilityActivation: "sigmoid", flipHorizontally: false, flipVertically: false };
var Wt = { kernelSize: 7, minConfidenceToRefine: 0.5 };
var Yt = { alpha: 0.1 };
var Gt = { oneEuroFilter: { frequency: 30, minCutOff: 0.05, beta: 80, derivateCutOff: 1, minAllowedObjectScale: 1e-6 } };
var Qt = { oneEuroFilter: { frequency: 30, minCutOff: 0.01, beta: 10, derivateCutOff: 1, minAllowedObjectScale: 1e-6 } };
var Zt = { oneEuroFilter: { frequency: 30, minCutOff: 0.1, beta: 40, derivateCutOff: 1, minAllowedObjectScale: 1e-6, disableValueScaling: true } };
var $t = { activation: "none" };
var Jt = { combineWithPreviousRatio: 0.7 };
var te = function() {
  function t2(t3) {
    this.mask = t3;
  }
  return t2.prototype.toCanvasImageSource = function() {
    return L(this, void 0, void 0, function() {
      return B(this, function(t3) {
        return [2, W(this.mask)];
      });
    });
  }, t2.prototype.toImageData = function() {
    return L(this, void 0, void 0, function() {
      return B(this, function(t3) {
        return [2, Y(this.mask)];
      });
    });
  }, t2.prototype.toTensor = function() {
    return L(this, void 0, void 0, function() {
      return B(this, function(t3) {
        return [2, this.mask];
      });
    });
  }, t2.prototype.getUnderlyingType = function() {
    return "tensor";
  }, t2;
}();
function ee(t2) {
  return Q(t2), "person";
}
var ie = function() {
  function t2(t3, e, i, n, r, o) {
    this.detectorModel = t3, this.landmarkModel = e, this.enableSmoothing = i, this.enableSegmentation = n, this.smoothSegmentation = r, this.modelType = o, this.regionOfInterest = null, this.prevFilteredSegmentationMask = null, this.anchors = function(t4) {
      null == t4.reduceBoxesInLowestLayer && (t4.reduceBoxesInLowestLayer = false), null == t4.interpolatedScaleAspectRatio && (t4.interpolatedScaleAspectRatio = 1), null == t4.fixedAnchorSize && (t4.fixedAnchorSize = false);
      for (var e2 = [], i2 = 0; i2 < t4.numLayers; ) {
        for (var n2 = [], r2 = [], o2 = [], a2 = [], s = i2; s < t4.strides.length && t4.strides[s] === t4.strides[i2]; ) {
          var l2 = dt(t4.minScale, t4.maxScale, s, t4.strides.length);
          if (0 === s && t4.reduceBoxesInLowestLayer)
            o2.push(1), o2.push(2), o2.push(0.5), a2.push(0.1), a2.push(l2), a2.push(l2);
          else {
            for (var u2 = 0; u2 < t4.aspectRatios.length; ++u2)
              o2.push(t4.aspectRatios[u2]), a2.push(l2);
            if (t4.interpolatedScaleAspectRatio > 0) {
              var h2 = s === t4.strides.length - 1 ? 1 : dt(t4.minScale, t4.maxScale, s + 1, t4.strides.length);
              a2.push(Math.sqrt(l2 * h2)), o2.push(t4.interpolatedScaleAspectRatio);
            }
          }
          s++;
        }
        for (var c = 0; c < o2.length; ++c) {
          var p = Math.sqrt(o2[c]);
          n2.push(a2[c] / p), r2.push(a2[c] * p);
        }
        var f = 0, d = 0;
        if (t4.featureMapHeight.length > 0)
          f = t4.featureMapHeight[i2], d = t4.featureMapWidth[i2];
        else {
          var m = t4.strides[i2];
          f = Math.ceil(t4.inputSizeHeight / m), d = Math.ceil(t4.inputSizeWidth / m);
        }
        for (var g = 0; g < f; ++g)
          for (var y = 0; y < d; ++y)
            for (var v = 0; v < n2.length; ++v) {
              var x = { xCenter: (y + t4.anchorOffsetX) / d, yCenter: (g + t4.anchorOffsetY) / f, width: 0, height: 0 };
              t4.fixedAnchorSize ? (x.width = 1, x.height = 1) : (x.width = r2[v], x.height = n2[v]), e2.push(x);
            }
        i2 = s;
      }
      return e2;
    }(Lt);
    var a = tensor1d(this.anchors.map(function(t4) {
      return t4.width;
    })), l = tensor1d(this.anchors.map(function(t4) {
      return t4.height;
    })), u = tensor1d(this.anchors.map(function(t4) {
      return t4.xCenter;
    })), h = tensor1d(this.anchors.map(function(t4) {
      return t4.yCenter;
    }));
    this.anchorTensor = { x: u, y: h, w: a, h: l }, this.prevFilteredSegmentationMask = this.enableSegmentation ? tensor2d([], [0, 0]) : null;
  }
  return t2.prototype.estimatePoses = function(t3, e, i) {
    return L(this, void 0, void 0, function() {
      var n, o, a, s, l, c, p, d, m, g, y, v, x, w, k, b, M, S, T, P, O, A, I;
      return B(this, function(C) {
        switch (C.label) {
          case 0:
            return n = function(t4) {
              var e2;
              if (null == (e2 = null == t4 ? Nt : V({}, t4)).maxPoses && (e2.maxPoses = 1), e2.maxPoses <= 0)
                throw new Error("Invalid maxPoses " + e2.maxPoses + ". Should be > 0.");
              if (e2.maxPoses > 1)
                throw new Error("Multi-pose detection is not implemented yet. Please set maxPoses to 1.");
              return e2;
            }(e), null == t3 ? (this.reset(), [2, []]) : (this.maxPoses = n.maxPoses, this.timestamp = null != i ? 1e3 * i : gt(t3) ? 1e6 * t3.currentTime : null, o = it(t3), a = tidy(function() {
              return cast(rt(t3), "float32");
            }), null != (s = this.regionOfInterest) ? [3, 2] : [4, this.detectPose(a)]);
          case 1:
            if (0 === (l = C.sent()).length)
              return this.reset(), a.dispose(), [2, []];
            c = l[0], s = this.poseDetectionToRoi(c, o), C.label = 2;
          case 2:
            return [4, this.poseLandmarksByRoi(s, a)];
          case 3:
            return p = C.sent(), a.dispose(), null == p ? (this.reset(), [2, []]) : (d = p.landmarks, m = p.auxiliaryLandmarks, g = p.poseScore, y = p.worldLandmarks, v = p.segmentationMask, x = this.poseLandmarkFiltering(d, m, y, o), w = x.actualLandmarksFiltered, k = x.auxiliaryLandmarksFiltered, b = x.actualWorldLandmarksFiltered, M = this.poseLandmarksToRoi(k, o), this.regionOfInterest = M, S = this.smoothSegmentation && null != v ? this.poseSegmentationFiltering(v) : v, null != (T = null != w ? xt(w, o) : null) && T.forEach(function(t4, e2) {
              t4.name = K[e2];
            }), null != (P = b) && P.forEach(function(t4, e2) {
              t4.name = K[e2];
            }), O = { score: g, keypoints: T, keypoints3D: P }, null !== S && (A = tidy(function() {
              var t4 = expandDims(S, 2), e2 = pad(t4, [[0, 0], [0, 0], [0, 1]]);
              return mirrorPad(e2, [[0, 0], [0, 0], [0, 2]], "symmetric");
            }), this.smoothSegmentation || dispose(S), I = { maskValueToLabel: ee, mask: new te(A) }, O.segmentation = I), [2, [O]]);
        }
      });
    });
  }, t2.prototype.poseSegmentationFiltering = function(t3) {
    var e = this.prevFilteredSegmentationMask;
    return 0 === e.size ? this.prevFilteredSegmentationMask = t3 : (this.prevFilteredSegmentationMask = bt(e, t3, Jt), dispose(t3)), dispose(e), this.prevFilteredSegmentationMask;
  }, t2.prototype.dispose = function() {
    this.detectorModel.dispose(), this.landmarkModel.dispose(), dispose([this.anchorTensor.x, this.anchorTensor.y, this.anchorTensor.w, this.anchorTensor.h, this.prevFilteredSegmentationMask]);
  }, t2.prototype.reset = function() {
    this.regionOfInterest = null, this.enableSegmentation && (dispose(this.prevFilteredSegmentationMask), this.prevFilteredSegmentationMask = tensor2d([], [0, 0])), this.visibilitySmoothingFilterActual = null, this.visibilitySmoothingFilterAuxiliary = null, this.landmarksSmoothingFilterActual = null, this.landmarksSmoothingFilterAuxiliary = null;
  }, t2.prototype.detectPose = function(t3) {
    return L(this, void 0, void 0, function() {
      var e, i, n, r, o, a, s, l, u, h;
      return B(this, function(c) {
        switch (c.label) {
          case 0:
            return e = ft(t3, Ht), i = e.imageTensor, n = e.padding, r = this.detectorModel.predict(i), o = mt(r), a = o.boxes, [4, Mt([s = o.logits, a], this.anchorTensor, Dt)];
          case 1:
            return 0 === (l = c.sent()).length ? (dispose([i, r, s, a]), [2, l]) : [4, vt(l, this.maxPoses, Kt)];
          case 2:
            return u = c.sent(), h = function(t4, e2) {
              void 0 === t4 && (t4 = []);
              for (var i2 = e2.left, n2 = e2.top, r2 = e2.left + e2.right, o2 = e2.top + e2.bottom, a2 = 0; a2 < t4.length; a2++) {
                var s2 = t4[a2], l2 = s2.locationData.relativeBoundingBox, u2 = (l2.xMin - i2) / (1 - r2), h2 = (l2.yMin - n2) / (1 - o2), c2 = l2.width / (1 - r2), p = l2.height / (1 - o2);
                l2.xMin = u2, l2.yMin = h2, l2.width = c2, l2.height = p, l2.xMax = u2 + c2, l2.yMax = h2 + p;
                var f = s2.locationData.relativeKeypoints;
                f && f.forEach(function(t5) {
                  var e3 = (t5.x - i2) / (1 - r2), a3 = (t5.y - n2) / (1 - o2);
                  t5.x = e3, t5.y = a3;
                });
              }
              return t4;
            }(u, n), dispose([i, r, s, a]), [2, h];
        }
      });
    });
  }, t2.prototype.poseDetectionToRoi = function(t3, e) {
    return 0, 1, _t(st(t3, e, { rotationVectorEndKeypointIndex: 1, rotationVectorStartKeypointIndex: 0, rotationVectorTargetAngleDegree: 90 }), e, jt);
  }, t2.prototype.poseLandmarksByRoi = function(t3, e) {
    return L(this, void 0, void 0, function() {
      var i, n, r, o, a, s, l, u, h, c, p, d, m, g;
      return B(this, function(y) {
        switch (y.label) {
          case 0:
            if (i = it(e), n = ft(e, qt, t3), r = n.imageTensor, o = n.padding, a = n.transformationMatrix, "lite" !== this.modelType && "full" !== this.modelType && "heavy" !== this.modelType)
              throw new Error("Model type must be one of lite, full or heavy,but got " + this.modelType);
            return s = ["ld_3d", "output_poseflag", "activation_heatmap", "world_3d"], this.enableSegmentation && s.push("activation_segmentation"), l = this.landmarkModel.execute(r, s), [4, this.tensorsToPoseLandmarksAndSegmentation(l)];
          case 1:
            return null == (u = y.sent()) ? (dispose(l), dispose(r), [2, null]) : (h = u.landmarks, c = u.auxiliaryLandmarks, p = u.poseScore, d = u.worldLandmarks, m = u.segmentationMask, [4, this.poseLandmarksAndSegmentationInverseProjection(i, t3, o, a, h, c, d, m)]);
          case 2:
            return g = y.sent(), dispose(l), dispose(r), [2, V({ poseScore: p }, g)];
        }
      });
    });
  }, t2.prototype.poseLandmarksAndSegmentationInverseProjection = function(t3, e, i, n, o, a, u, h) {
    return L(this, void 0, void 0, function() {
      var c, d, m, g, y, v;
      return B(this, function(x) {
        return c = kt(o, i), d = kt(a, i), m = ct(c, e), g = ct(d, e), y = function(t4, e2) {
          for (var i2 = [], n2 = 0, r = t4; n2 < r.length; n2++) {
            var o2 = r[n2], a2 = o2.x, s = o2.y, l = e2.rotation, u2 = Math.cos(l) * a2 - Math.sin(l) * s, h2 = Math.sin(l) * a2 + Math.cos(l) * s, c2 = V({}, o2);
            c2.x = u2, c2.y = h2, i2.push(c2);
          }
          return i2;
        }(u, e), v = null, this.enableSegmentation && (v = tidy(function() {
          var e2 = h.shape, i2 = e2[0], r = e2[1], o2 = function(t4) {
            var e3 = lt(new Array(16).fill(0));
            e3[0][0] = ht(t4, 0, 0), e3[1][0] = -ht(t4, 0, 1), e3[2][0] = ht(t4, 0, 2), e3[3][0] = -ht(t4, 0, 3), e3[0][2] = ht(t4, 2, 0), e3[1][2] = -ht(t4, 2, 1), e3[2][2] = ht(t4, 2, 2), e3[3][2] = -ht(t4, 2, 3), e3[0][1] = -ht(t4, 1, 0), e3[1][1] = ht(t4, 1, 1), e3[2][1] = -ht(t4, 1, 2), e3[3][1] = ht(t4, 1, 3), e3[0][3] = -ht(t4, 3, 0), e3[1][3] = ht(t4, 3, 1), e3[2][3] = -ht(t4, 3, 2), e3[3][3] = ht(t4, 3, 3);
            for (var i3 = t4[0][0] * e3[0][0] + t4[1][0] * e3[0][1] + t4[2][0] * e3[0][2] + t4[3][0] * e3[0][3], n2 = 0; n2 < e3.length; n2++)
              for (var r2 = 0; r2 < e3.length; r2++)
                e3[n2][r2] /= i3;
            return e3;
          }(n), a2 = tensor2d(ot(o2, { width: r, height: i2 }, t3), [1, 8]), u2 = [1, i2, r, 1];
          return squeeze(image.transform(reshape(h, u2), a2, "bilinear", "constant", 0, [t3.height, t3.width]), [0, 3]);
        }), dispose(h)), [2, { landmarks: m, auxiliaryLandmarks: g, worldLandmarks: y, segmentationMask: v }];
      });
    });
  }, t2.prototype.tensorsToPoseLandmarksAndSegmentation = function(t3) {
    return L(this, void 0, void 0, function() {
      var e, i, n, o, a, s, u, h, c, f, d, m, g;
      return B(this, function(y) {
        switch (y.label) {
          case 0:
            return e = t3[0], i = t3[1], n = t3[2], o = t3[3], a = this.enableSegmentation ? t3[4] : null, [4, i.data()];
          case 1:
            return (s = y.sent()[0]) < 0.5 ? [2, null] : [4, Ft(e, Ut)];
          case 2:
            return [4, wt(y.sent(), n, Wt)];
          case 3:
            return u = y.sent(), h = u.slice(0, 33), c = u.slice(33, 35), [4, Ft(o, Xt)];
          case 4:
            return f = y.sent(), d = f.slice(0, 33), m = function(t4, e2, i2) {
              void 0 === i2 && (i2 = true);
              for (var n2 = [], r = 0; r < t4.length; r++) {
                var o2 = V({}, e2[r]);
                i2 && (o2.score = t4[r].score), n2.push(o2);
              }
              return n2;
            }(h, d, true), g = this.enableSegmentation ? function(t4, e2, i2) {
              return tidy(function() {
                var n2 = squeeze(t4, [0]), r = n2.shape[2];
                if (1 === r) {
                  var o2 = n2;
                  switch (e2.activation) {
                    case "none":
                      break;
                    case "sigmoid":
                      o2 = sigmoid(o2);
                      break;
                    case "softmax":
                      throw new Error("Softmax activation requires two channels.");
                    default:
                      throw new Error("Activation not supported (" + e2.activation + ")");
                  }
                  var a2 = i2 ? image.resizeBilinear(o2, [i2.height, i2.width]) : o2;
                  return squeeze(a2, [2]);
                }
                throw new Error("Unsupported number of tensor channels " + r);
              });
            }(a, $t) : null, [2, { landmarks: h, auxiliaryLandmarks: c, poseScore: s, worldLandmarks: m, segmentationMask: g }];
        }
      });
    });
  }, t2.prototype.poseLandmarksToRoi = function(t3, e) {
    return _t(st(yt(t3), e, { rotationVectorStartKeypointIndex: 0, rotationVectorEndKeypointIndex: 1, rotationVectorTargetAngleDegree: 90 }), e, jt);
  }, t2.prototype.poseLandmarkFiltering = function(t3, e, i, n) {
    var r, o, a;
    if (null != this.timestamp && this.enableSmoothing) {
      var s = st(yt(e), n, { rotationVectorEndKeypointIndex: 0, rotationVectorStartKeypointIndex: 1, rotationVectorTargetAngleDegree: 90 });
      null == this.visibilitySmoothingFilterActual && (this.visibilitySmoothingFilterActual = new Vt(Yt)), r = this.visibilitySmoothingFilterActual.apply(t3), null == this.visibilitySmoothingFilterAuxiliary && (this.visibilitySmoothingFilterAuxiliary = new Vt(Yt)), o = this.visibilitySmoothingFilterAuxiliary.apply(e), a = this.visibilitySmoothingFilterActual.apply(i), null == this.landmarksSmoothingFilterActual && (this.landmarksSmoothingFilterActual = new zt(Gt)), r = this.landmarksSmoothingFilterActual.apply(r, this.timestamp, n, true, s), null == this.landmarksSmoothingFilterAuxiliary && (this.landmarksSmoothingFilterAuxiliary = new zt(Qt)), o = this.landmarksSmoothingFilterAuxiliary.apply(o, this.timestamp, n, true, s), null == this.worldLandmarksSmoothingFilterActual && (this.worldLandmarksSmoothingFilterActual = new zt(Zt)), a = this.worldLandmarksSmoothingFilterActual.apply(i, this.timestamp);
    } else
      r = t3, o = e, a = i;
    return { actualLandmarksFiltered: r, auxiliaryLandmarksFiltered: o, actualWorldLandmarksFiltered: a };
  }, t2;
}();
function ne(t2) {
  return L(this, void 0, void 0, function() {
    var e, i, n, r, o, a;
    return B(this, function(s) {
      switch (s.label) {
        case 0:
          return e = function(t3) {
            var e2 = V({}, null == t3 ? Bt : t3);
            if (null == e2.enableSmoothing && (e2.enableSmoothing = Bt.enableSmoothing), null == e2.enableSegmentation && (e2.enableSegmentation = Bt.enableSegmentation), null == e2.smoothSegmentation && (e2.smoothSegmentation = Bt.smoothSegmentation), null == e2.modelType && (e2.modelType = Bt.modelType), null == e2.detectorModelUrl && (e2.detectorModelUrl = Bt.detectorModelUrl), null == e2.landmarkModelUrl)
              switch (e2.modelType) {
                case "lite":
                  e2.landmarkModelUrl = "https://tfhub.dev/mediapipe/tfjs-model/blazepose_3d/landmark/lite/2";
                  break;
                case "heavy":
                  e2.landmarkModelUrl = "https://tfhub.dev/mediapipe/tfjs-model/blazepose_3d/landmark/heavy/2";
                  break;
                case "full":
                default:
                  e2.landmarkModelUrl = "https://tfhub.dev/mediapipe/tfjs-model/blazepose_3d/landmark/full/2";
              }
            return e2;
          }(t2), i = "string" == typeof e.detectorModelUrl && e.detectorModelUrl.indexOf("https://tfhub.dev") > -1, n = "string" == typeof e.landmarkModelUrl && e.landmarkModelUrl.indexOf("https://tfhub.dev") > -1, [4, Promise.all([loadGraphModel(e.detectorModelUrl, { fromTFHub: i }), loadGraphModel(e.landmarkModelUrl, { fromTFHub: n })])];
        case 1:
          return r = s.sent(), o = r[0], a = r[1], [2, new ie(o, a, e.enableSmoothing, e.enableSegmentation, e.smoothSegmentation, e.modelType)];
      }
    });
  });
}
var re;
var oe;
var ae = function() {
  function t2(t3) {
    !function(t4) {
      if (t4.maxTracks < 1)
        throw new Error("Must specify 'maxTracks' to be at least 1, but encountered " + t4.maxTracks);
      if (t4.maxAge <= 0)
        throw new Error("Must specify 'maxAge' to be positive, but encountered " + t4.maxAge);
      if (void 0 !== t4.keypointTrackerParams) {
        if (t4.keypointTrackerParams.keypointConfidenceThreshold < 0 || t4.keypointTrackerParams.keypointConfidenceThreshold > 1)
          throw new Error("Must specify 'keypointConfidenceThreshold' to be in the range [0, 1], but encountered " + t4.keypointTrackerParams.keypointConfidenceThreshold);
        if (t4.keypointTrackerParams.minNumberOfKeypoints < 1)
          throw new Error("Must specify 'minNumberOfKeypoints' to be at least 1, but encountered " + t4.keypointTrackerParams.minNumberOfKeypoints);
        for (var e = 0, i = t4.keypointTrackerParams.keypointFalloff; e < i.length; e++) {
          var n = i[e];
          if (n <= 0)
            throw new Error("Must specify each keypoint falloff parameterto be positive but encountered " + n);
        }
      }
    }(t3), this.tracks = [], this.maxTracks = t3.maxTracks, this.maxAge = 1e3 * t3.maxAge, this.minSimilarity = t3.minSimilarity, this.nextID = 1;
  }
  return t2.prototype.apply = function(t3, e) {
    this.filterOldTracks(e);
    var i = this.computeSimilarity(t3);
    return this.assignTracks(t3, i, e), this.updateTracks(e), t3;
  }, t2.prototype.getTracks = function() {
    return this.tracks.slice();
  }, t2.prototype.getTrackIDs = function() {
    return new Set(this.tracks.map(function(t3) {
      return t3.id;
    }));
  }, t2.prototype.filterOldTracks = function(t3) {
    var e = this;
    this.tracks = this.tracks.filter(function(i) {
      return t3 - i.lastTimestamp <= e.maxAge;
    });
  }, t2.prototype.assignTracks = function(t3, e, i) {
    for (var n = Array.from(Array(e[0].length).keys()), r = [], o = 0, a = Array.from(Array(t3.length).keys()); o < a.length; o++) {
      var s = a[o];
      if (0 !== n.length) {
        for (var l = -1, u = -1, h = 0, c = n; h < c.length; h++) {
          var p = c[h], f = e[s][p];
          f >= this.minSimilarity && f > u && (l = p, u = f);
        }
        if (l >= 0) {
          var d = this.tracks[l];
          d = Object.assign(d, this.createTrack(t3[s], i, d.id)), t3[s].id = d.id;
          var m = n.indexOf(l);
          n.splice(m, 1);
        } else
          r.push(s);
      } else
        r.push(s);
    }
    for (var g = 0, y = r; g < y.length; g++) {
      s = y[g];
      var v = this.createTrack(t3[s], i);
      this.tracks.push(v), t3[s].id = v.id;
    }
  }, t2.prototype.updateTracks = function(t3) {
    this.tracks.sort(function(t4, e) {
      return e.lastTimestamp - t4.lastTimestamp;
    }), this.tracks = this.tracks.slice(0, this.maxTracks);
  }, t2.prototype.createTrack = function(t3, e, i) {
    var n = { id: i || this.nextTrackID(), lastTimestamp: e, keypoints: N(t3.keypoints).map(function(t4) {
      return V({}, t4);
    }) };
    return void 0 !== t3.box && (n.box = V({}, t3.box)), n;
  }, t2.prototype.nextTrackID = function() {
    var t3 = this.nextID;
    return this.nextID += 1, t3;
  }, t2.prototype.remove = function() {
    for (var t3 = [], e = 0; e < arguments.length; e++)
      t3[e] = arguments[e];
    this.tracks = this.tracks.filter(function(e2) {
      return !t3.includes(e2.id);
    });
  }, t2.prototype.reset = function() {
    this.tracks = [];
  }, t2;
}();
var se = function(t2) {
  function e(e2) {
    return t2.call(this, e2) || this;
  }
  return z(e, t2), e.prototype.computeSimilarity = function(t3) {
    var e2 = this;
    return 0 === t3.length || 0 === this.tracks.length ? [[]] : t3.map(function(t4) {
      return e2.tracks.map(function(i) {
        return e2.iou(t4, i);
      });
    });
  }, e.prototype.iou = function(t3, e2) {
    var i = Math.max(t3.box.xMin, e2.box.xMin), n = Math.max(t3.box.yMin, e2.box.yMin), r = Math.min(t3.box.xMax, e2.box.xMax), o = Math.min(t3.box.yMax, e2.box.yMax);
    if (i >= r || n >= o)
      return 0;
    var a = (r - i) * (o - n);
    return a / (t3.box.width * t3.box.height + e2.box.width * e2.box.height - a);
  }, e;
}(ae);
var le = function(t2) {
  function e(e2) {
    var i = t2.call(this, e2) || this;
    return i.keypointThreshold = e2.keypointTrackerParams.keypointConfidenceThreshold, i.keypointFalloff = e2.keypointTrackerParams.keypointFalloff, i.minNumKeyoints = e2.keypointTrackerParams.minNumberOfKeypoints, i;
  }
  return z(e, t2), e.prototype.computeSimilarity = function(t3) {
    if (0 === t3.length || 0 === this.tracks.length)
      return [[]];
    for (var e2 = [], i = 0, n = t3; i < n.length; i++) {
      for (var r = n[i], o = [], a = 0, s = this.tracks; a < s.length; a++) {
        var l = s[a];
        o.push(this.oks(r, l));
      }
      e2.push(o);
    }
    return e2;
  }, e.prototype.oks = function(t3, e2) {
    for (var i = this.area(e2.keypoints) + 1e-6, n = 0, r = 0, o = 0; o < t3.keypoints.length; ++o) {
      var a = t3.keypoints[o], s = e2.keypoints[o];
      if (!(a.score < this.keypointThreshold || s.score < this.keypointThreshold)) {
        r += 1;
        var l = Math.pow(a.x - s.x, 2) + Math.pow(a.y - s.y, 2), u = 2 * this.keypointFalloff[o];
        n += Math.exp(-1 * l / (2 * i * Math.pow(u, 2)));
      }
    }
    return r < this.minNumKeyoints ? 0 : n / r;
  }, e.prototype.area = function(t3) {
    var e2 = this, i = t3.filter(function(t4) {
      return t4.score > e2.keypointThreshold;
    }), n = Math.min.apply(Math, N([1], i.map(function(t4) {
      return t4.x;
    }))), r = Math.max.apply(Math, N([0], i.map(function(t4) {
      return t4.x;
    }))), o = Math.min.apply(Math, N([1], i.map(function(t4) {
      return t4.y;
    })));
    return (r - n) * (Math.max.apply(Math, N([0], i.map(function(t4) {
      return t4.y;
    }))) - o);
  }, e;
}(ae);
function ue(t2) {
  switch (t2) {
    case oe.BlazePose:
      return K.reduce(function(t3, e, i) {
        return t3[e] = i, t3;
      }, {});
    case oe.PoseNet:
    case oe.MoveNet:
      return D.reduce(function(t3, e, i) {
        return t3[e] = i, t3;
      }, {});
    default:
      throw new Error("Model " + t2 + " is not supported.");
  }
}
!function(t2) {
  t2.Keypoint = "keypoint", t2.BoundingBox = "boundingBox";
}(re || (re = {})), function(t2) {
  t2.MoveNet = "MoveNet", t2.BlazePose = "BlazePose", t2.PoseNet = "PoseNet";
}(oe || (oe = {}));
var he = Object.freeze({ __proto__: null, getKeypointIndexBySide: function(t2) {
  switch (t2) {
    case oe.BlazePose:
      return j;
    case oe.PoseNet:
    case oe.MoveNet:
      return H;
    default:
      throw new Error("Model " + t2 + " is not supported.");
  }
}, getAdjacentPairs: function(t2) {
  switch (t2) {
    case oe.BlazePose:
      return U;
    case oe.PoseNet:
    case oe.MoveNet:
      return q;
    default:
      throw new Error("Model " + t2 + " is not supported.");
  }
}, getKeypointIndexByName: ue });
var ce = ["SinglePose.Lightning", "SinglePose.Thunder", "MultiPose.Lightning"];
var pe = { modelType: "SinglePose.Lightning", enableSmoothing: true };
var fe = {};
var de = { frequency: 30, minCutOff: 2.5, beta: 300, derivateCutOff: 2.5, thresholdCutOff: 0.5, thresholdBeta: 5, disableValueScaling: true };
var me = { maxTracks: 18, maxAge: 1e3, minSimilarity: 0.2, keypointTrackerParams: { keypointConfidenceThreshold: 0.3, keypointFalloff: [0.026, 0.025, 0.025, 0.035, 0.035, 0.079, 0.079, 0.072, 0.072, 0.062, 0.062, 0.107, 0.107, 0.087, 0.087, 0.089, 0.089], minNumberOfKeypoints: 4 } };
var ge = { maxTracks: 18, maxAge: 1e3, minSimilarity: 0.15, trackerParams: {} };
function ye(t2, e, i, n) {
  for (var r = {}, o = 0, a = D; o < a.length; o++) {
    var s = a[o];
    r[s] = [e[i[s]].y * n.height, e[i[s]].x * n.width];
  }
  if (function(t3, e2) {
    return (t3[e2.left_hip].score > 0.2 || t3[e2.right_hip].score > 0.2) && (t3[e2.left_shoulder].score > 0.2 || t3[e2.right_shoulder].score > 0.2);
  }(e, i)) {
    var l = (r.left_hip[0] + r.right_hip[0]) / 2, u = (r.left_hip[1] + r.right_hip[1]) / 2, h = function(t3, e2, i2, n2, r2) {
      for (var o2 = ["left_shoulder", "right_shoulder", "left_hip", "right_hip"], a2 = 0, s2 = 0, l2 = 0; l2 < o2.length; l2++) {
        (f2 = Math.abs(n2 - i2[o2[l2]][0])) > a2 && (a2 = f2), (d2 = Math.abs(r2 - i2[o2[l2]][1])) > s2 && (s2 = d2);
      }
      for (var u2 = 0, h2 = 0, c2 = 0, p2 = Object.keys(i2); c2 < p2.length; c2++) {
        var f2, d2, m2 = p2[c2];
        if (!(t3[e2[m2]].score < 0.2))
          (f2 = Math.abs(n2 - i2[m2][0])) > u2 && (u2 = f2), (d2 = Math.abs(r2 - i2[m2][1])) > h2 && (h2 = d2);
      }
      return [a2, s2, u2, h2];
    }(e, i, r, l, u), c = h[0], p = h[1], f = h[2], d = h[3], m = Math.max(1.9 * p, 1.9 * c, 1.2 * f, 1.2 * d), g = [l - (m = Math.min(m, Math.max(u, n.width - u, l, n.height - l))), u - m];
    if (m > Math.max(n.width, n.height) / 2)
      return ve(null == t2, n);
    var y = 2 * m;
    return { yMin: g[0] / n.height, xMin: g[1] / n.width, yMax: (g[0] + y) / n.height, xMax: (g[1] + y) / n.width, height: (g[0] + y) / n.height - g[0] / n.height, width: (g[1] + y) / n.width - g[1] / n.width };
  }
  return ve(null == t2, n);
}
function ve(t2, e) {
  var i, n, r, o;
  return t2 ? e.width > e.height ? (i = 1, n = e.height / e.width, r = 0, o = (e.width / 2 - e.height / 2) / e.width) : (i = e.width / e.height, n = 1, r = (e.height / 2 - e.width / 2) / e.height, o = 0) : e.width > e.height ? (i = e.width / e.height, n = 1, r = (e.height / 2 - e.width / 2) / e.height, o = 0) : (i = 1, n = e.height / e.width, r = 0, o = (e.width / 2 - e.height / 2) / e.width), { yMin: r, xMin: o, yMax: r + i, xMax: o + n, height: i, width: n };
}
function xe(t2) {
  var e, i = null == t2 ? pe : V({}, t2);
  if (null == i.modelType)
    i.modelType = "SinglePose.Lightning";
  else if (ce.indexOf(i.modelType) < 0)
    throw new Error("Invalid architecture " + i.modelType + ". Should be one of " + ce);
  if (null == i.enableSmoothing && (i.enableSmoothing = true), null != i.minPoseScore && (i.minPoseScore < 0 || i.minPoseScore > 1))
    throw new Error("minPoseScore should be between 0.0 and 1.0");
  if (null != i.multiPoseMaxDimension && (i.multiPoseMaxDimension % 32 != 0 || i.multiPoseMaxDimension < 32))
    throw new Error("multiPoseMaxDimension must be a multiple of 32 and higher than 0");
  if ("MultiPose.Lightning" === i.modelType && null == i.enableTracking && (i.enableTracking = true), "MultiPose.Lightning" === i.modelType && true === i.enableTracking)
    if (null == i.trackerType && (i.trackerType = re.BoundingBox), i.trackerType === re.Keypoint)
      null != i.trackerConfig ? i.trackerConfig = function(t3) {
        var e2 = we(me, t3);
        e2.keypointTrackerParams = V({}, me.keypointTrackerParams), null != t3.keypointTrackerParams && (null != t3.keypointTrackerParams.keypointConfidenceThreshold && (e2.keypointTrackerParams.keypointConfidenceThreshold = t3.keypointTrackerParams.keypointConfidenceThreshold), null != t3.keypointTrackerParams.keypointFalloff && (e2.keypointTrackerParams.keypointFalloff = t3.keypointTrackerParams.keypointFalloff), null != t3.keypointTrackerParams.minNumberOfKeypoints && (e2.keypointTrackerParams.minNumberOfKeypoints = t3.keypointTrackerParams.minNumberOfKeypoints));
        return e2;
      }(i.trackerConfig) : i.trackerConfig = me;
    else {
      if (i.trackerType !== re.BoundingBox)
        throw new Error("Tracker type not supported by MoveNet");
      null != i.trackerConfig ? i.trackerConfig = (e = i.trackerConfig, we(ge, e)) : i.trackerConfig = ge;
    }
  return i;
}
function we(t2, e) {
  var i = { maxTracks: t2.maxTracks, maxAge: t2.maxAge, minSimilarity: t2.minSimilarity };
  return null != e.maxTracks && (i.maxTracks = e.maxTracks), null != e.maxAge && (i.maxAge = e.maxAge), null != e.minSimilarity && (i.minSimilarity = e.minSimilarity), i;
}
var ke = function() {
  function t2(t3, e) {
    this.moveNetModel = t3, this.modelInputResolution = { height: 0, width: 0 }, this.keypointIndexByName = ue(oe.MoveNet), "SinglePose.Lightning" === e.modelType ? (this.modelInputResolution.width = 192, this.modelInputResolution.height = 192) : "SinglePose.Thunder" === e.modelType && (this.modelInputResolution.width = 256, this.modelInputResolution.height = 256), this.multiPoseModel = "MultiPose.Lightning" === e.modelType, this.multiPoseModel || (this.keypointFilter = new Ct(de), this.cropRegionFilterYMin = new At(0.9), this.cropRegionFilterXMin = new At(0.9), this.cropRegionFilterYMax = new At(0.9), this.cropRegionFilterXMax = new At(0.9)), this.enableSmoothing = e.enableSmoothing, e.minPoseScore ? this.minPoseScore = e.minPoseScore : this.minPoseScore = 0.25, e.multiPoseMaxDimension ? this.multiPoseMaxDimension = e.multiPoseMaxDimension : this.multiPoseMaxDimension = 256, this.enableTracking = e.enableTracking, this.multiPoseModel && this.enableTracking && (e.trackerType === re.Keypoint ? this.tracker = new le(e.trackerConfig) : e.trackerType === re.BoundingBox && (this.tracker = new se(e.trackerConfig)), this.enableSmoothing && (this.keypointFilterMap = /* @__PURE__ */ new Map()));
  }
  return t2.prototype.runSinglePersonPoseModel = function(t3) {
    return L(this, void 0, void 0, function() {
      var e, i, n, r, o;
      return B(this, function(a) {
        switch (a.label) {
          case 0:
            if (4 !== (e = this.moveNetModel.execute(t3)).shape.length || 1 !== e.shape[0] || 1 !== e.shape[1] || 17 !== e.shape[2] || 3 !== e.shape[3])
              throw e.dispose(), new Error("Unexpected output shape from model: [" + e.shape + "]");
            return "webgpu" === getBackend() ? [3, 1] : (i = e.dataSync(), [3, 3]);
          case 1:
            return [4, e.data()];
          case 2:
            i = a.sent(), a.label = 3;
          case 3:
            for (e.dispose(), n = { keypoints: [], score: 0 }, r = 0, o = 0; o < 17; ++o)
              n.keypoints[o] = { y: i[3 * o], x: i[3 * o + 1], score: i[3 * o + 2] }, n.keypoints[o].score > 0.2 && (++r, n.score += n.keypoints[o].score);
            return r > 0 && (n.score /= r), [2, n];
        }
      });
    });
  }, t2.prototype.runMultiPersonPoseModel = function(t3) {
    return L(this, void 0, void 0, function() {
      var e, i, n, r, o, a, s, l;
      return B(this, function(u) {
        switch (u.label) {
          case 0:
            if (3 !== (e = this.moveNetModel.execute(t3)).shape.length || 1 !== e.shape[0] || 56 !== e.shape[2])
              throw e.dispose(), new Error("Unexpected output shape from model: [" + e.shape + "]");
            return "webgpu" === getBackend() ? [3, 1] : (i = e.dataSync(), [3, 3]);
          case 1:
            return [4, e.data()];
          case 2:
            i = u.sent(), u.label = 3;
          case 3:
            for (e.dispose(), n = [], r = i.length / 56, o = 0; o < r; ++o)
              for (n[o] = { keypoints: [] }, a = 56 * o + 51, n[o].box = { yMin: i[a], xMin: i[a + 1], yMax: i[a + 2], xMax: i[a + 3], width: i[a + 3] - i[a + 1], height: i[a + 2] - i[a] }, s = 56 * o + 55, n[o].score = i[s], n[o].keypoints = [], l = 0; l < 17; ++l)
                n[o].keypoints[l] = { y: i[56 * o + 3 * l], x: i[56 * o + 3 * l + 1], score: i[56 * o + 3 * l + 2] };
            return [2, n];
        }
      });
    });
  }, t2.prototype.estimatePoses = function(t3, i, n) {
    return void 0 === i && (i = fe), L(this, void 0, void 0, function() {
      var r, o, a, s, l, h;
      return B(this, function(c) {
        switch (c.label) {
          case 0:
            return i = function(t4) {
              return null == t4 ? fe : V({}, t4);
            }(i), null == t3 ? (this.reset(), [2, []]) : (null == n ? gt(t3) && (n = 1e6 * t3.currentTime) : n *= 1e3, r = rt(t3), o = it(r), a = expandDims(r, 0), t3 instanceof Tensor || r.dispose(), s = [], this.multiPoseModel ? [3, 2] : [4, this.estimateSinglePose(a, o, n)]);
          case 1:
            return s = c.sent(), [3, 4];
          case 2:
            return [4, this.estimateMultiplePoses(a, o, n)];
          case 3:
            s = c.sent(), c.label = 4;
          case 4:
            for (l = 0; l < s.length; ++l)
              for (h = 0; h < s[l].keypoints.length; ++h)
                s[l].keypoints[h].name = D[h], s[l].keypoints[h].y *= o.height, s[l].keypoints[h].x *= o.width;
            return [2, s];
        }
      });
    });
  }, t2.prototype.estimateSinglePose = function(t3, e, i) {
    return L(this, void 0, void 0, function() {
      var n, o, a, u, c = this;
      return B(this, function(p) {
        switch (p.label) {
          case 0:
            return this.cropRegion || (this.cropRegion = ve(null == this.cropRegion, e)), n = tidy(function() {
              var e2 = tensor2d([[c.cropRegion.yMin, c.cropRegion.xMin, c.cropRegion.yMax, c.cropRegion.xMax]]), i2 = zeros([1], "int32"), n2 = [c.modelInputResolution.height, c.modelInputResolution.width];
              return cast(image.cropAndResize(t3, e2, i2, n2, "bilinear", 0), "int32");
            }), t3.dispose(), [4, this.runSinglePersonPoseModel(n)];
          case 1:
            if (o = p.sent(), n.dispose(), o.score < this.minPoseScore)
              return this.reset(), [2, []];
            for (a = 0; a < o.keypoints.length; ++a)
              o.keypoints[a].y = this.cropRegion.yMin + o.keypoints[a].y * this.cropRegion.height, o.keypoints[a].x = this.cropRegion.xMin + o.keypoints[a].x * this.cropRegion.width;
            return null != i && this.enableSmoothing && (o.keypoints = this.keypointFilter.apply(o.keypoints, i, 1)), u = ye(this.cropRegion, o.keypoints, this.keypointIndexByName, e), this.cropRegion = this.filterCropRegion(u), [2, [o]];
        }
      });
    });
  }, t2.prototype.estimateMultiplePoses = function(t3, e, i) {
    return L(this, void 0, void 0, function() {
      var n, r, o, a, s, u, c, p, f, d, m, g = this;
      return B(this, function(y) {
        switch (y.label) {
          case 0:
            return 32, e.width > e.height ? (r = this.multiPoseMaxDimension, o = Math.round(this.multiPoseMaxDimension * e.height / e.width), n = image.resizeBilinear(t3, [o, r]), s = r, u = 32 * Math.ceil(o / 32), a = pad(n, [[0, 0], [0, u - o], [0, 0], [0, 0]])) : (r = Math.round(this.multiPoseMaxDimension * e.width / e.height), o = this.multiPoseMaxDimension, n = image.resizeBilinear(t3, [o, r]), s = 32 * Math.ceil(r / 32), u = o, a = pad(n, [[0, 0], [0, 0], [0, s - r], [0, 0]])), n.dispose(), t3.dispose(), c = cast(a, "int32"), a.dispose(), [4, this.runMultiPersonPoseModel(c)];
          case 1:
            for (p = y.sent(), c.dispose(), p = p.filter(function(t4) {
              return t4.score >= g.minPoseScore;
            }), d = 0; d < p.length; ++d)
              for (f = 0; f < p[d].keypoints.length; ++f)
                p[d].keypoints[f].y *= u / o, p[d].keypoints[f].x *= s / r;
            if (this.enableTracking && (this.tracker.apply(p, i), this.enableSmoothing)) {
              for (d = 0; d < p.length; ++d)
                this.keypointFilterMap.has(p[d].id) || this.keypointFilterMap.set(p[d].id, new Ct(de)), p[d].keypoints = this.keypointFilterMap.get(p[d].id).apply(p[d].keypoints, i, 1);
              m = this.tracker.getTrackIDs(), this.keypointFilterMap.forEach(function(t4, e2) {
                m.has(e2) || g.keypointFilterMap.delete(e2);
              });
            }
            return [2, p];
        }
      });
    });
  }, t2.prototype.filterCropRegion = function(t3) {
    if (t3) {
      var e = this.cropRegionFilterYMin.apply(t3.yMin), i = this.cropRegionFilterXMin.apply(t3.xMin), n = this.cropRegionFilterYMax.apply(t3.yMax), r = this.cropRegionFilterXMax.apply(t3.xMax);
      return { yMin: e, xMin: i, yMax: n, xMax: r, height: n - e, width: r - i };
    }
    return this.cropRegionFilterYMin.reset(), this.cropRegionFilterXMin.reset(), this.cropRegionFilterYMax.reset(), this.cropRegionFilterXMax.reset(), null;
  }, t2.prototype.dispose = function() {
    this.moveNetModel.dispose();
  }, t2.prototype.reset = function() {
    this.cropRegion = null, this.resetFilters();
  }, t2.prototype.resetFilters = function() {
    this.keypointFilter.reset(), this.cropRegionFilterYMin.reset(), this.cropRegionFilterXMin.reset(), this.cropRegionFilterYMax.reset(), this.cropRegionFilterXMax.reset();
  }, t2;
}();
function be(t2) {
  return void 0 === t2 && (t2 = pe), L(this, void 0, void 0, function() {
    var e, i, n, r;
    return B(this, function(o) {
      switch (o.label) {
        case 0:
          return e = xe(t2), n = true, e.modelUrl ? (n = "string" == typeof e.modelUrl && e.modelUrl.indexOf("https://tfhub.dev") > -1, [4, loadGraphModel(e.modelUrl, { fromTFHub: n })]) : [3, 2];
        case 1:
          return i = o.sent(), [3, 4];
        case 2:
          return r = void 0, "SinglePose.Lightning" === e.modelType ? r = "https://tfhub.dev/google/tfjs-model/movenet/singlepose/lightning/4" : "SinglePose.Thunder" === e.modelType ? r = "https://tfhub.dev/google/tfjs-model/movenet/singlepose/thunder/4" : "MultiPose.Lightning" === e.modelType && (r = "https://tfhub.dev/google/tfjs-model/movenet/multipose/lightning/1"), [4, loadGraphModel(r, { fromTFHub: n })];
        case 3:
          i = o.sent(), o.label = 4;
        case 4:
          return "webgl" === getBackend() && env().set("TOPK_LAST_DIM_CPU_HANDOFF_SIZE_THRESHOLD", 0), [2, new ke(i, e)];
      }
    });
  });
}
var Me = { architecture: "MobileNetV1", outputStride: 16, multiplier: 0.75, inputResolution: { height: 257, width: 257 } };
var Se = ["MobileNetV1", "ResNet50"];
var Te = { MobileNetV1: [8, 16], ResNet50: [16] };
var Pe = [8, 16, 32];
var Fe = { MobileNetV1: [0.5, 0.75, 1], ResNet50: [1] };
var _e = [1, 2, 4];
var Oe = { maxPoses: 1, flipHorizontal: false };
var Ae = { maxPoses: 5, flipHorizontal: false, scoreThreshold: 0.5, nmsRadius: 20 };
var Ie = [-123.15, -115.9, -103.06];
function Ce(t2) {
  return Math.floor(t2 / 2);
}
var Re = function() {
  function t2(t3, e) {
    this.priorityQueue = new Array(t3), this.numberOfElements = -1, this.getElementValue = e;
  }
  return t2.prototype.enqueue = function(t3) {
    this.priorityQueue[++this.numberOfElements] = t3, this.swim(this.numberOfElements);
  }, t2.prototype.dequeue = function() {
    var t3 = this.priorityQueue[0];
    return this.exchange(0, this.numberOfElements--), this.sink(0), this.priorityQueue[this.numberOfElements + 1] = null, t3;
  }, t2.prototype.empty = function() {
    return -1 === this.numberOfElements;
  }, t2.prototype.size = function() {
    return this.numberOfElements + 1;
  }, t2.prototype.all = function() {
    return this.priorityQueue.slice(0, this.numberOfElements + 1);
  }, t2.prototype.max = function() {
    return this.priorityQueue[0];
  }, t2.prototype.swim = function(t3) {
    for (; t3 > 0 && this.less(Ce(t3), t3); )
      this.exchange(t3, Ce(t3)), t3 = Ce(t3);
  }, t2.prototype.sink = function(t3) {
    for (; 2 * t3 <= this.numberOfElements; ) {
      var e = 2 * t3;
      if (e < this.numberOfElements && this.less(e, e + 1) && e++, !this.less(t3, e))
        break;
      this.exchange(t3, e), t3 = e;
    }
  }, t2.prototype.getValueAt = function(t3) {
    return this.getElementValue(this.priorityQueue[t3]);
  }, t2.prototype.less = function(t3, e) {
    return this.getValueAt(t3) < this.getValueAt(e);
  }, t2.prototype.exchange = function(t3, e) {
    var i = this.priorityQueue[t3];
    this.priorityQueue[t3] = this.priorityQueue[e], this.priorityQueue[e] = i;
  }, t2;
}();
function Ee(t2, e, i, n, r, o) {
  for (var a = o.shape, s = a[0], l = a[1], u = true, h = Math.max(i - r, 0), c = Math.min(i + r + 1, s), p = h; p < c; ++p) {
    for (var f = Math.max(n - r, 0), d = Math.min(n + r + 1, l), m = f; m < d; ++m)
      if (o.get(p, m, t2) > e) {
        u = false;
        break;
      }
    if (!u)
      break;
  }
  return u;
}
function ze(t2) {
  return L(this, void 0, void 0, function() {
    return B(this, function(e) {
      return [2, Promise.all(t2.map(function(t3) {
        return t3.buffer();
      }))];
    });
  });
}
function Ve(t2, e, i, n) {
  return { y: n.get(t2, e, i), x: n.get(t2, e, i + 17) };
}
function Le(t2, e, i) {
  var n = Ve(t2.heatmapY, t2.heatmapX, t2.id, i), r = n.y, o = n.x;
  return { x: t2.heatmapX * e + o, y: t2.heatmapY * e + r };
}
function Be(t2, e, i, n) {
  var r = i.x, o = i.y;
  return t2.some(function(t3) {
    var i2, a, s, l, u, h, c = t3.keypoints;
    return i2 = o, a = r, s = c[n].y, l = c[n].x, (u = s - i2) * u + (h = l - a) * h <= e;
  });
}
var Ne = D.reduce(function(t2, e, i) {
  return t2[e] = i, t2;
}, {});
var De = [["nose", "left_eye"], ["left_eye", "left_ear"], ["nose", "right_eye"], ["right_eye", "right_ear"], ["nose", "left_shoulder"], ["left_shoulder", "left_elbow"], ["left_elbow", "left_wrist"], ["left_shoulder", "left_hip"], ["left_hip", "left_knee"], ["left_knee", "left_ankle"], ["nose", "right_shoulder"], ["right_shoulder", "right_elbow"], ["right_elbow", "right_wrist"], ["right_shoulder", "right_hip"], ["right_hip", "right_knee"], ["right_knee", "right_ankle"]].map(function(t2) {
  var e = t2[0], i = t2[1];
  return [Ne[e], Ne[i]];
});
var Ke = De.map(function(t2) {
  return t2[1];
});
var je = De.map(function(t2) {
  return t2[0];
});
function He(t2, e, i) {
  return t2 < e ? e : t2 > i ? i : t2;
}
function qe(t2, e, i, n) {
  return { y: He(Math.round(t2.y / e), 0, i - 1), x: He(Math.round(t2.x / e), 0, n - 1) };
}
function Ue(t2, e) {
  return { x: t2.x + e.x, y: t2.y + e.y };
}
function Xe(t2, e, i, n, r, o, a, s) {
  void 0 === s && (s = 2);
  for (var l = n.shape, u = l[0], h = l[1], c = { y: e.y, x: e.x }, p = Ue(c, function(t3, e2, i2) {
    var n2 = i2.shape[2] / 2;
    return { y: i2.get(e2.y, e2.x, t3), x: i2.get(e2.y, e2.x, n2 + t3) };
  }(t2, qe(c, o, u, h), a)), f = 0; f < s; f++) {
    var d = qe(p, o, u, h), m = Ve(d.y, d.x, i, r);
    p = Ue({ x: d.x * o, y: d.y * o }, { x: m.x, y: m.y });
  }
  var g = qe(p, o, u, h), y = n.get(g.y, g.x, i);
  return { y: p.y, x: p.x, name: D[i], score: y };
}
function We(t2, e, i, n, r, o) {
  var a = e.shape[2], s = Ke.length, l = new Array(a), u = t2.part, h = t2.score, c = Le(u, n, i);
  l[u.id] = { score: h, name: D[u.id], y: c.y, x: c.x };
  for (var p = s - 1; p >= 0; --p) {
    var f = Ke[p], d = je[p];
    l[f] && !l[d] && (l[d] = Xe(p, l[f], d, e, i, n, o));
  }
  for (p = 0; p < s; ++p) {
    f = je[p], d = Ke[p];
    l[f] && !l[d] && (l[d] = Xe(p, l[f], d, e, i, n, r));
  }
  return l;
}
function Ye(t2, e, i) {
  return i.reduce(function(i2, n, r) {
    var o = n.y, a = n.x, s = n.score;
    return Be(t2, e, { y: o, x: a }, r) || (i2 += s), i2;
  }, 0) / i.length;
}
function Ge(t2, e, i, n, r, o, a, s) {
  return void 0 === a && (a = 0.5), void 0 === s && (s = 20), L(this, void 0, void 0, function() {
    var l, u, h, c, p, f, d, m, g, y, v, x;
    return B(this, function(w) {
      switch (w.label) {
        case 0:
          return [4, ze([t2, e, i, n])];
        case 1:
          for (l = w.sent(), u = l[0], h = l[1], c = l[2], p = l[3], f = [], d = function(t3, e2, i2) {
            for (var n2 = i2.shape, r2 = n2[0], o2 = n2[1], a2 = n2[2], s2 = new Re(r2 * o2 * a2, function(t4) {
              return t4.score;
            }), l2 = 0; l2 < r2; ++l2)
              for (var u2 = 0; u2 < o2; ++u2)
                for (var h2 = 0; h2 < a2; ++h2) {
                  var c2 = i2.get(l2, u2, h2);
                  c2 < t3 || Ee(h2, c2, l2, u2, e2, i2) && s2.enqueue({ score: c2, part: { heatmapY: l2, heatmapX: u2, id: h2 } });
                }
            return s2;
          }(a, 1, u), m = s * s; f.length < o && !d.empty(); )
            g = d.dequeue(), y = Le(g.part, r, h), Be(f, m, y, g.part.id) || (v = We(g, u, h, r, c, p), x = Ye(f, m, v), f.push({ keypoints: v, score: x }));
          return [2, f];
      }
    });
  });
}
function Qe(t2) {
  var e = t2.shape, i = e[0], n = e[1], o = e[2];
  return tidy(function() {
    var e2, s, l = reshape(t2, [i * n, o]), h = argMax(l, 0), c = expandDims(div(h, scalar(n, "int32")), 1), p = expandDims((e2 = h, s = n, tidy(function() {
      var t3 = div(e2, scalar(s, "int32"));
      return sub(e2, mul(t3, scalar(s, "int32")));
    })), 1);
    return concat([c, p], 1);
  });
}
function Ze(t2, e, i) {
  return tidy(function() {
    var n = function(t3, e2) {
      for (var i2 = [], n2 = 0; n2 < D.length; n2++) {
        var r = t3.get(n2, 0).valueOf(), o = t3.get(n2, 1).valueOf(), a = $e(r, o, n2, e2), l = a.x, u = a.y;
        i2.push(u), i2.push(l);
      }
      return tensor2d(i2, [D.length, 2]);
    }(t2, i);
    return add(cast(mul(t2.toTensor(), scalar(e, "int32")), "float32"), n);
  });
}
function $e(t2, e, i, n) {
  return { y: n.get(t2, e, i), x: n.get(t2, e, i + D.length) };
}
function Je(t2, e, i) {
  return L(this, void 0, void 0, function() {
    var n, r, o, a, s, l, u, h, c, p;
    return B(this, function(f) {
      switch (f.label) {
        case 0:
          return n = 0, r = Qe(t2), [4, Promise.all([t2.buffer(), e.buffer(), r.buffer()])];
        case 1:
          return o = f.sent(), a = o[0], s = o[1], l = o[2], [4, (u = Ze(l, i, s)).buffer()];
        case 2:
          return h = f.sent(), c = Array.from(function(t3, e2) {
            for (var i2 = e2.shape[0], n2 = new Float32Array(i2), r2 = 0; r2 < i2; r2++) {
              var o2 = e2.get(r2, 0), a2 = e2.get(r2, 1);
              n2[r2] = t3.get(o2, a2, r2);
            }
            return n2;
          }(a, l)), p = c.map(function(t3, e2) {
            return n += t3, { y: h.get(e2, 0), x: h.get(e2, 1), score: t3, name: D[e2] };
          }), r.dispose(), u.dispose(), [2, { keypoints: p, score: n / p.length }];
      }
    });
  });
}
function ti(t2, e) {
  return (t2 - 1) % e == 0;
}
var ei = "https://storage.googleapis.com/tfjs-models/savedmodel/posenet/mobilenet/";
var ii = "https://storage.googleapis.com/tfjs-models/savedmodel/posenet/resnet50/";
function ni(t2, e) {
  return function(t3, e2) {
    return (t3 - 1) % e2 == 0;
  }(t2, e) ? t2 : Math.floor(t2 / e) * e + 1;
}
var ri = function() {
  function t2(t3, e) {
    this.posenetModel = t3;
    var i = this.posenetModel.inputs[0].shape;
    util_exports.assert(-1 === i[1] && -1 === i[2], function() {
      return "Input shape [" + i[1] + ", " + i[2] + "] must both be equal to or -1";
    });
    var r, o, a = (r = e.inputResolution, o = e.outputStride, { height: ni(r.height, o), width: ni(r.width, o) });
    !function(t4) {
      util_exports.assert(Pe.indexOf(t4) >= 0, function() {
        return "outputStride of " + t4 + " is invalid. It must be either 8 or 16.";
      });
    }(e.outputStride), function(t4, e2) {
      util_exports.assert(ti(t4.height, e2), function() {
        return "height of " + t4.height + " is invalid for output stride " + e2 + ".";
      }), util_exports.assert(ti(t4.width, e2), function() {
        return "width of " + t4.width + " is invalid for output stride " + e2 + ".";
      });
    }(a, e.outputStride), this.inputResolution = a, this.outputStride = e.outputStride, this.architecture = e.architecture;
  }
  return t2.prototype.estimatePoses = function(t3, e) {
    return void 0 === e && (e = Oe), L(this, void 0, void 0, function() {
      var i, n, r, a, s, l, u, h, c, d, m, g, y, v, x;
      return B(this, function(w) {
        switch (w.label) {
          case 0:
            return i = function(t4) {
              var e2 = t4;
              if (null == e2.maxPoses && (e2.maxPoses = 1), e2.maxPoses <= 0)
                throw new Error("Invalid maxPoses " + e2.maxPoses + ". Should be > 0.");
              if (e2.maxPoses > 1) {
                if ((e2 = V(V({}, Ae), e2)).scoreThreshold < 0 || e2.scoreThreshold > 1)
                  throw new Error("Invalid scoreThreshold " + e2.scoreThreshold + ". Should be in range [0.0, 1.0]");
                if (e2.nmsRadius <= 0)
                  throw new Error("Invalid nmsRadius " + e2.nmsRadius + ".");
              }
              return e2;
            }(e), null == t3 ? [2, []] : (this.maxPoses = i.maxPoses, n = ft(t3, { outputTensorSize: this.inputResolution, keepAspectRatio: true, borderMode: "replicate" }), r = n.imageTensor, a = n.padding, s = "ResNet50" === this.architecture ? add(r, Ie) : pt(r, [-1, 1]), l = this.posenetModel.predict(s), "ResNet50" === this.architecture ? (u = squeeze(l[2], [0]), h = squeeze(l[3], [0]), c = squeeze(l[0], [0]), d = squeeze(l[1], [0])) : (u = squeeze(l[0], [0]), h = squeeze(l[1], [0]), c = squeeze(l[2], [0]), d = squeeze(l[3], [0])), m = sigmoid(h), 1 !== this.maxPoses ? [3, 2] : [4, Je(m, u, this.outputStride)]);
          case 1:
            return y = w.sent(), g = [y], [3, 4];
          case 2:
            return [4, Ge(m, u, c, d, this.outputStride, this.maxPoses, i.scoreThreshold, i.nmsRadius)];
          case 3:
            g = w.sent(), w.label = 4;
          case 4:
            return v = it(t3), x = function(t4, e2, i2, n2) {
              var r2 = e2.height, o = e2.width, a2 = r2 / (i2.height * (1 - n2.top - n2.bottom)), s2 = o / (i2.width * (1 - n2.left - n2.right)), l2 = -n2.top * i2.height, u2 = -n2.left * i2.width;
              if (1 === s2 && 1 === a2 && 0 === l2 && 0 === u2)
                return t4;
              for (var h2 = 0, c2 = t4; h2 < c2.length; h2++)
                for (var p = 0, f = c2[h2].keypoints; p < f.length; p++) {
                  var d2 = f[p];
                  d2.x = (d2.x + u2) * s2, d2.y = (d2.y + l2) * a2;
                }
              return t4;
            }(g, v, this.inputResolution, a), i.flipHorizontal && (x = function(t4, e2) {
              for (var i2 = 0, n2 = t4; i2 < n2.length; i2++)
                for (var r2 = 0, o = n2[i2].keypoints; r2 < o.length; r2++) {
                  var a2 = o[r2];
                  a2.x = e2.width - 1 - a2.x;
                }
              return t4;
            }(x, v)), r.dispose(), s.dispose(), dispose(l), u.dispose(), h.dispose(), c.dispose(), d.dispose(), m.dispose(), [2, x];
        }
      });
    });
  }, t2.prototype.dispose = function() {
    this.posenetModel.dispose();
  }, t2.prototype.reset = function() {
  }, t2;
}();
function oi(t2) {
  return void 0 === t2 && (t2 = Me), L(this, void 0, void 0, function() {
    var e, i, n, r, o;
    return B(this, function(a) {
      switch (a.label) {
        case 0:
          return "ResNet50" !== (e = function(t3) {
            var e2 = t3 || Me;
            if (null == e2.architecture && (e2.architecture = "MobileNetV1"), Se.indexOf(e2.architecture) < 0)
              throw new Error("Invalid architecture " + e2.architecture + ". Should be one of " + Se);
            if (null == e2.inputResolution && (e2.inputResolution = { height: 257, width: 257 }), null == e2.outputStride && (e2.outputStride = 16), Te[e2.architecture].indexOf(e2.outputStride) < 0)
              throw new Error("Invalid outputStride " + e2.outputStride + ". Should be one of " + Te[e2.architecture] + " for architecture " + e2.architecture + ".");
            if (null == e2.multiplier && (e2.multiplier = 1), Fe[e2.architecture].indexOf(e2.multiplier) < 0)
              throw new Error("Invalid multiplier " + e2.multiplier + ". Should be one of " + Fe[e2.architecture] + " for architecture " + e2.architecture + ".");
            if (null == e2.quantBytes && (e2.quantBytes = 4), _e.indexOf(e2.quantBytes) < 0)
              throw new Error("Invalid quantBytes " + e2.quantBytes + ". Should be one of " + _e + " for architecture " + e2.architecture + ".");
            if ("MobileNetV1" === e2.architecture && 32 === e2.outputStride && 1 !== e2.multiplier)
              throw new Error("When using an output stride of 32, you must select 1 as the multiplier.");
            return e2;
          }(t2)).architecture ? [3, 2] : (s = e.outputStride, l = e.quantBytes, u = "model-stride" + s + ".json", i = 4 === l ? ii + "float/" + u : ii + "quant" + l + "/" + u, [4, loadGraphModel(e.modelUrl || i)]);
        case 1:
          return n = a.sent(), [2, new ri(n, e)];
        case 2:
          return r = function(t3, e2, i2) {
            var n2 = { 1: "100", 0.75: "075", 0.5: "050" }, r2 = "model-stride" + t3 + ".json";
            return 4 === i2 ? ei + "float/" + n2[e2] + "/" + r2 : ei + "quant" + i2 + "/" + n2[e2] + "/" + r2;
          }(e.outputStride, e.multiplier, e.quantBytes), [4, loadGraphModel(e.modelUrl || r)];
        case 3:
          return o = a.sent(), [2, new ri(o, e)];
      }
      var s, l, u;
    });
  });
}
function ai(t2, e) {
  return L(this, void 0, void 0, function() {
    var i, n;
    return B(this, function(r) {
      switch (t2) {
        case oe.PoseNet:
          return [2, oi(e)];
        case oe.BlazePose:
          if (n = void 0, null != (i = e)) {
            if ("tfjs" === i.runtime)
              return [2, ne(e)];
            if ("mediapipe" === i.runtime)
              return [2, et(e)];
            n = i.runtime;
          }
          throw new Error("Expect modelConfig.runtime to be either 'tfjs' or 'mediapipe', but got " + n);
        case oe.MoveNet:
          return [2, be(e)];
        default:
          throw new Error(t2 + " is not a supported model name.");
      }
    });
  });
}
var si = { keypointsToNormalizedKeypoints: Ot };
var li = { modelType: { SINGLEPOSE_LIGHTNING: "SinglePose.Lightning", SINGLEPOSE_THUNDER: "SinglePose.Thunder", MULTIPOSE_LIGHTNING: "MultiPose.Lightning" } };
export {
  oe as SupportedModels,
  re as TrackerType,
  si as calculators,
  ai as createDetector,
  li as movenet,
  he as util
};
/**
    * @license
    * Copyright 2022 Google LLC. All Rights Reserved.
    * Licensed under the Apache License, Version 2.0 (the "License");
    * you may not use this file except in compliance with the License.
    * You may obtain a copy of the License at
    *
    * http://www.apache.org/licenses/LICENSE-2.0
    *
    * Unless required by applicable law or agreed to in writing, software
    * distributed under the License is distributed on an "AS IS" BASIS,
    * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    * See the License for the specific language governing permissions and
    * limitations under the License.
    * =============================================================================
    */
//# sourceMappingURL=@tensorflow-models_pose-detection.js.map
